{
  "about.blocks": "کارسازهای نظارت شده",
  "about.contact": "تماس:",
  "about.default_locale": "پیش‌گزیده",
  "about.disclaimer": "ماستودون نرم‌افزار آزاد و نشان تجاری یک شرکت غیر انتفاعی با مسئولیت محدود آلمانی است.",
  "about.domain_blocks.no_reason_available": "دلیلی موجود نیست",
  "about.domain_blocks.preamble": "ماستودون عموماً می‌گذارد محتوا را از هر کارساز دیگری در دنیای شبکه‌های اجتماعی غیرمتمرکز دیده و با آنان برهم‌کنش داشته باشید. این‌ها استثناهایی هستند که روی این کارساز خاص وضع شده‌اند.",
  "about.domain_blocks.silenced.explanation": "عموماً نمایه‌ها و محتوا از این کارساز را نمی‌بینید، مگر این که به طور خاص دنبالشان گشته یا با پی گیری، داوطلب دیدنشان شوید.",
  "about.domain_blocks.silenced.title": "محدود",
  "about.domain_blocks.suspended.explanation": "هیچ داده‌ای از این کارساز پردازش، ذخیره یا مبادله نخواهد شد، که هرگونه برهم‌کنش یا ارتباط با کاربران این کارساز را غیرممکن خواهد کرد.",
  "about.domain_blocks.suspended.title": "معلق",
  "about.language_label": "زبان",
  "about.not_available": "این اطّلاعات روی این کارساز موجود نشده.",
  "about.powered_by": "رسانهٔ اجتماعی نامتمرکز قدرت گرفته از {mastodon}",
  "about.rules": "قوانین کارساز",
  "account.account_note_header": "یادداشت شخصی",
  "account.activity": "فعّالیت",
  "account.add_note": "افزودن یادداشت شخصی",
  "account.add_or_remove_from_list": "افزودن یا برداشتن از سیاهه‌ها",
  "account.badges.admin": "مدیر",
  "account.badges.blocked": "مسدود",
  "account.badges.bot": "خودکار",
  "account.badges.domain_blocked": "دامنهٔ مسدود",
  "account.badges.group": "گروه",
  "account.badges.muted": "خموش",
  "account.badges.muted_until": "خموش تا {until}",
  "account.block": "انسداد ‎@{name}",
  "account.block_domain": "انسداد دامنهٔ {domain}",
  "account.block_short": "انسداد",
  "account.blocked": "مسدود",
  "account.cancel_follow_request": "رد کردن درخواست پی‌گیری",
  "account.copy": "رونوشت از پیوند به نمایه",
  "account.direct": "اشارهٔ خصوصی به ‪@{name}‬",
  "account.disable_notifications": "آگاه کردن من هنگام فرسته‌های ‎@{name} را متوقّف کن",
  "account.edit_note": "ویرایش یادداشت شخصی",
  "account.edit_profile": "ویرایش نمایه",
  "account.edit_profile_short": "ویرایش",
  "account.enable_notifications": "هنگام فرسته‌های ‎@{name} مرا آگاه کن",
  "account.endorse": "معرّفی در نمایه",
  "account.familiar_followers_many": "پی‌گرفته از سوی {name1}، {name2} و {othersCount, plural,one {یکی دیگر از پی‌گرفته‌هایتان} other {# نفر دیگر از پی‌گرفته‌هایتان}}",
  "account.familiar_followers_one": "پی‌گرفته از سوی {name1}",
  "account.familiar_followers_two": "پی‌گرفته از سوی {name1} و {name2}",
  "account.featured": "پیشنهادی",
  "account.featured.accounts": "نمایه‌ها",
  "account.featured.collections": "مجموعه‌ها",
  "account.featured.new_collection": "مجموعهٔ جدید",
  "account.field_overflow": "نمایش همهٔ محتوا",
  "account.filters.all": "همهٔ فعّالیت‌ها",
  "account.filters.boosts_toggle": "نمایش تقویت‌ها",
  "account.filters.posts_boosts": "فرسته‌ها و تقویت‌ها",
  "account.filters.posts_only": "فرسته‌ها",
  "account.filters.posts_replies": "فرسته‌ها و پاسخ‌ها",
  "account.filters.replies_toggle": "نمایش پاسخ‌ها",
  "account.follow": "پی‌گرفتن",
  "account.follow_back": "پی‌گیری متقابل",
  "account.follow_back_short": "پی‌گیری متقابل",
  "account.follow_request": "درخواست پی‌گیری",
  "account.follow_request_cancel": "لغو درخواست",
  "account.follow_request_cancel_short": "لغو",
  "account.follow_request_short": "درخواست",
  "account.followers": "پی‌گیرنده",
  "account.followers.empty": "هنوز کسی پی‌گیر این کاربر نیست.",
  "account.followers_counter": "{count, plural, one {{counter} پی‌گیرنده} other {{counter} پی‌گیرنده}}",
  "account.followers_you_know_counter": "{counter} نفر را می‌شناسید",
  "account.following": "پی‌گرفته",
  "account.following_counter": "{count, plural, one {{counter} پی‌گرفته} other {{counter} پی‌گرفته}}",
  "account.follows.empty": "این کاربر هنوز پی‌گیر کسی نیست.",
  "account.follows_you": "پی‌گیرتان است",
  "account.go_to_profile": "رفتن به نمایه",
  "account.hide_reblogs": "نهفتن تقویت‌های ‎@{name}",
  "account.in_memoriam": "به یادبود.",
  "account.join_modal.day": "روز",
  "account.join_modal.me": "تاریخ پیوستنتان به {server}",
  "account.join_modal.me_anniversary": "وبروزتان مبارک! پیوسته به {server} در",
  "account.join_modal.me_today": "نخستین روزتان روی {server} است!",
  "account.join_modal.other": "تاریخ پیوستن {name} به {server}",
  "account.join_modal.other_today": "نخستین روز {name} روی {server} است!",
  "account.join_modal.share.celebrate": "هم‌رسانی فرستهٔ جشن",
  "account.join_modal.share.intro": "هم‌رسانی فرستهٔ معرّفی",
  "account.join_modal.share.welcome": "هم‌رسانی فرستهٔ خوش‌آمد",
  "account.join_modal.years": "{number, plural, one {سال} other {سال}}",
  "account.joined_short": "پیوسته",
  "account.languages": "تغییر زبان‌های مشترک شده",
  "account.last_active": "آخرین فعّالیت",
  "account.link_verified_on": "مالکیت این پیوند در {date} بررسی شد",
  "account.locked_info": "این حساب خصوصی است. صاحبش تصمیم می‌گیرد که چه کسی پی‌گیرش باشد.",
  "account.media": "رسانه",
  "account.mention": "اشاره به ‎@{name}",
  "account.menu.add_to_list": "افزودن به سیاهه…",
  "account.menu.block": "مسدود کردن حساب",
  "account.menu.block_domain": "مسدود کردن {domain}",
  "account.menu.copied": "پیوند حساب در تخته‌گیره رونوشت شد",
  "account.menu.copy": "رونوشت از پیوند",
  "account.menu.direct": "اشارهٔ خصوصی",
  "account.menu.hide_reblogs": "نهفتن تقویت‌ها در خط زمانی",
  "account.menu.mention": "اشاره",
  "account.menu.mute": "خموشی حساب",
  "account.menu.note.description": "نمایان تنها برای شما",
  "account.menu.open_original_page": "دیدن روی {domain}",
  "account.menu.remove_follower": "برداشتن پی‌گیرنده",
  "account.menu.report": "گزارش حساب",
  "account.menu.share": "هم‌رسانی…",
  "account.menu.show_reblogs": "نمایش تقویت‌ها در خط زمانی",
  "account.menu.unblock": "رفع مسدودی حساب",
  "account.menu.unblock_domain": "رفع مسدودی {domain}",
  "account.menu.unmute": "ناخموشی حساب",
  "account.moved_to": "{name} نشان داده که حساب جدیدش این است:",
  "account.mute": "خموشاندن ‎@{name}",
  "account.mute_notifications_short": "خموشی آگاهی‌ها",
  "account.mute_short": "خموشی",
  "account.muted": "خموش",
  "account.mutual": "یکدیگر را پی می‌گیرید",
  "account.name.copy": "رونوشت از شناسه",
  "account.name.help.domain": "‫{domain} کارساز میزبان نماگر و فرسته‌های کاربر است.",
  "account.name.help.domain_self": "‫{domain} کارساز میزبان نماگر و فرسته‌هایتان است.",
  "account.name.help.footer": "همان‌طور که می‌توانید به افرادی که از فراهم‌کنندگان مختلف رایانامه استفاده می‌کنند رایانامه بفرستید؛ می‌توانید با افرادی که روی کارسازهای دیگر ماستودون و هر کارهٔ وب اجتماعی دیگری هستند تعامل داشته باشید.",
  "account.name.help.header": "شناسه مانند نشانی رایانامه است",
  "account.name.help.username": "‫{username} نام کاربری این حساب روی کارسازش است. ممکن است کسی روی کارسازی دیگر نیز همین نام کاربری را داشته باشد.",
  "account.name.help.username_self": "‫{username} نام کاربریتان روی این کارساز است. ممکن است کسی روی کارسازی دیگر نیز همین نام کاربری را داشته باشد.",
  "account.name_info": "معنایش چیست؟",
  "account.no_bio": "شرحی فراهم نشده.",
  "account.node_modal.callout": "یادداشت‌های شخصی تنها برای شما نمایانند.",
  "account.node_modal.edit_title": "ویرایش یادداشت شخصی",
  "account.node_modal.error_unknown": "نتوانست یادداشت را ذخیره کند",
  "account.node_modal.field_label": "یادداشت شخصی",
  "account.node_modal.save": "ذخیره",
  "account.node_modal.title": "افزودن یادداشت شخصی",
  "account.note.edit_button": "ویرایش",
  "account.note.title": "یادداشت‌های شخصی (تنها برای شما نمایانند)",
  "account.open_original_page": "گشودن صفحهٔ اصلی",
  "account.pending": "منتظر",
  "account.posts": "فرسته",
  "account.remove_from_followers": "برداشتن {name} از پی‌گیران",
  "account.report": "گزارش ‎@{name}",
  "account.requested_follow": "{name} درخواست پی‌گیریتان را داد",
  "account.share": "هم‌رسانی نمایهٔ ‎@{name}",
  "account.show_reblogs": "نمایش تقویت‌های ‎@{name}",
  "account.statuses_counter": "{count, plural, one {{counter} فرسته} other {{counter} فرسته}}",
  "account.timeline.pinned": "سنجاق شده",
  "account.timeline.pinned.view_all": "دیدن همهٔ فرسته‌های سنجاق شده",
  "account.unblock": "رفع مسدودیت ‎@{name}",
  "account.unblock_domain": "رفع مسدودیت دامنهٔ {domain}",
  "account.unblock_domain_short": "آنبلاک",
  "account.unblock_short": "رفع مسدودیت",
  "account.unendorse": "معرّفی نکردن در نمایه",
  "account.unfollow": "پی‌نگرفتن",
  "account.unmute": "ناخموشی ‎@{name}",
  "account.unmute_notifications_short": "ناخموشی آگاهی‌ها",
  "account.unmute_short": "ناخموشی",
  "account_edit.advanced_settings.bot_hint": "علامت به دیگران که حساب بیشتر به طور خودکار فعالیت می‌کند و نظارت پیوسته‌ای روی آن وجود ندارد",
  "account_edit.advanced_settings.bot_label": "حساب خودکار",
  "account_edit.advanced_settings.title": "تنظیمات پیش‌رفته",
  "account_edit.bio.add_label": "افزودن شرح‌حال",
  "account_edit.bio.edit_label": "ویرایش شرح‌حال",
  "account_edit.bio.placeholder": "افزودن معرّفی کوتاهی برای کمک به شناساییتان.",
  "account_edit.bio.title": "شرح‌حال",
  "account_edit.bio_modal.add_title": "افزودن شرح‌حال",
  "account_edit.bio_modal.edit_title": "ویرایش شرح‌حال",
  "account_edit.column_button": "انجام شد",
  "account_edit.column_title": "ویرایش نماگر",
  "account_edit.custom_fields.add_label": "افزودن زمینه",
  "account_edit.custom_fields.edit_label": "ویرایش زمینه",
  "account_edit.custom_fields.placeholder": "افزودن ضمایر، پیوندهای خارجی یا هر چیز دیگری که می‌خواهید هم‌رسانی کنید.",
  "account_edit.custom_fields.reorder_button": "جابه‌جایی زمینه‌ها",
  "account_edit.custom_fields.tip_content": "به سادگی می‌توانید با تأیید کردن پیوندها به هر پایگاه وبی که مالکش هستید به حساب ماستودونتان اعتبار دهید.",
  "account_edit.custom_fields.tip_title": "راهنما: افزودن پیوندهای تأیید شده",
  "account_edit.custom_fields.title": "زمینه‌های سفارشی",
  "account_edit.custom_fields.verified_hint": "چگونه پیوند تأیید شده‌ای بیفزایم؟",
  "account_edit.display_name.add_label": "افزودن نام نمایشی",
  "account_edit.display_name.edit_label": "ویرایش نام نمایشی",
  "account_edit.display_name.placeholder": "نام نمایشی نامیست که در خط‌های زمانی روی نماگرتان نشان داده می‌شود.",
  "account_edit.display_name.title": "نام نمایشی",
  "account_edit.featured_hashtags.edit_label": "افزودن برچسب",
  "account_edit.featured_hashtags.placeholder": "کمک به دیگران در شناسایی و دسترسی سریع به موضوع‌های محبوبتان.",
  "account_edit.featured_hashtags.title": "برچسب‌های معرّفی شده",
  "account_edit.field_actions.delete": "حذف زمینه",
  "account_edit.field_actions.edit": "ویرایش زمینه",
  "account_edit.field_delete_modal.confirm": "مطمئنید که می‌خواهید این زمینهٔ سفارشی را حذف کنید؟ این کار بازگشت‌پذیر نیست.",
  "account_edit.field_delete_modal.delete_button": "حذف",
  "account_edit.field_delete_modal.title": "حذف زمینهٔ سفارشی؟",
  "account_edit.field_edit_modal.add_title": "افزودن زمینهٔ سفارشی",
  "account_edit.field_edit_modal.discard_confirm": "دور انداختن",
  "account_edit.field_edit_modal.discard_message": "تغییراتی ذخیره نشده دارید. مطمئنید که می‌خواهید دور بیندازیدشان؟",
  "account_edit.field_edit_modal.edit_title": "ویرایش زمینهٔ سفارشی",
  "account_edit.field_edit_modal.length_warning": "از کران پیشنهادی نویسه‌ها رد شد. ممکن است کاربران همراه زمینه‌تان را کامل نبینند.",
  "account_edit.field_edit_modal.link_emoji_warning": "توصیه نمی‌کنیم از شکلک‌های سفارشی در ترکیب با نشانی‌ها استفاده کنید. زمینه‌های سفارشی دارای هر دو برای جلوگیری از گیجی کاربران به جای پیوند، به شکل فقط متنی نشان داده خواهند شد.",
  "account_edit.field_edit_modal.name_hint": "نمونه: «پایگاه وب شخصی»",
  "account_edit.field_edit_modal.name_label": "عنوان",
  "account_edit.field_edit_modal.url_warning": "برای افزودن پیوند {protocol} را در ابتدا بیفزایید.",
  "account_edit.field_edit_modal.value_hint": "نمونه: https://example.me",
  "account_edit.field_edit_modal.value_label": "مقدار",
  "account_edit.field_reorder_modal.drag_cancel": "کشیدن لغو شد. زمینهٔ {item} حذف شد.",
  "account_edit.field_reorder_modal.drag_end": "زمینهٔ {item} حذف شد.",
  "account_edit.field_reorder_modal.drag_instructions": "برای جابه‌جا کردن زمینه‌های سفارشی، فاصله یا ورود را بزنید. هنگام کشیدن از کلیدهای جهت‌دار برای جابه‌جایی زمینه به بالا یا پایین استفاده کنید. برای رها کردن زمینه در موقعیت جدیدش دوباره فاصله یا ورود را زده یا برای لغو، گریز را بزنید.",
  "account_edit.field_reorder_modal.drag_move": "زمینهٔ {item} جابه‌جا شد.",
  "account_edit.field_reorder_modal.drag_over": "زمینهٔ {item} روی {over} جابه‌جا شد.",
  "account_edit.field_reorder_modal.drag_start": "زمینهٔ {item} بلند شد.",
  "account_edit.field_reorder_modal.handle_label": "کشیدن زمینهٔ {item}",
  "account_edit.field_reorder_modal.title": "جابه‌جا کردن زمینه‌ها",
  "account_edit.image_alt_modal.add_title": "افزودن متن جایگزین",
  "account_edit.image_alt_modal.details_content": "مثبت: <ul> <li>توصیف خودتان به گونهٔ تصویر شده</li> <li>استفاده از زبان سوم‌شخص (نمونه: «دانیال» به جای «من»)</li> <li>کم گوی و گزیده گوی چون دُر</li> </ul>منفی: <ul> <li>آغاز با «عکس» – برای خواننده‌ّای صفحه تکراری است</li> </ul>نمونه: <ul> <li>«دانیال با تی‌شرت سبز و عینک»</li> </ul>",
  "account_edit.image_alt_modal.details_title": "راهنما: متن جایگزین برای عکس‌های نماگر",
  "account_edit.image_alt_modal.edit_title": "ویرایش متن جایگزین",
  "account_edit.image_alt_modal.text_hint": "متن جایگزین به کاربران خوانندهٔ صفحه کمک می‌کند تا بافتارتان را درک کنند.",
  "account_edit.image_alt_modal.text_label": "متن جایگزین",
  "account_edit.image_delete_modal.confirm": "مطمئنید که می‌خواهید این تصویر را حذف کنید؟ این کار بازگشت‌پذیر نیست.",
  "account_edit.image_delete_modal.delete_button": "حذف",
  "account_edit.image_delete_modal.title": "حذف تصویر؟",
  "account_edit.image_edit.add_button": "افزودن تصویر",
  "account_edit.image_edit.alt_add_button": "افزودن متن جایگزین",
  "account_edit.image_edit.alt_edit_button": "ویرایش متن جایگزین",
  "account_edit.image_edit.remove_button": "برداشتن تصویر",
  "account_edit.image_edit.replace_button": "جایگزینی تصویر",
  "account_edit.item_list.delete": "حذف {name}",
  "account_edit.item_list.edit": "ویرایش {name}",
  "account_edit.name_modal.add_title": "افزودن نام نمایشی",
  "account_edit.name_modal.edit_title": "ویرایش نام نمایشی",
  "account_edit.profile_tab.button_label": "سفارشی سازی",
  "account_edit.profile_tab.hint.description": "این تنظیمات آن‌چه که کاربران در کاره‌های رسمی روی {server} می‌بینند را سفارشی می‌کند؛ ولی ممکن است به کاربران روی کارسازهای دیگر و کاره‌های سوم‌شخص اعمال نشود.",
  "account_edit.profile_tab.hint.title": "نمایش‌ها همچنان متفاوتند",
  "account_edit.profile_tab.show_featured.description": "«معرّفی شده» زبانه‌ای اختیاریست که می‌توانید حساب‌های دیگر را در آن به نمایش بگذارید.",
  "account_edit.profile_tab.show_featured.title": "نمایش زبانهٔ «معرّفی شده»",
  "account_edit.profile_tab.show_media.description": "«رسانه» زبانه‌ای اختیاریست که فرسته‌های دارای تصویر یا ویدیویتان را نشان می‌دهد.",
  "account_edit.profile_tab.show_media.title": "نمایش زبانهٔ «رسانه»",
  "account_edit.profile_tab.show_media_replies.description": "هنگام به کار افتادن، زبانهٔ رسانه فرسته‌ها و پاسخ‌ها به فرسته‌های دیگران را نشان می‌دهد.",
  "account_edit.profile_tab.show_media_replies.title": "شامل پاسخ‌ها در زبانهٔ «رسانه»",
  "account_edit.profile_tab.show_relations.description": "نمایش حساب‌هایی که پی می‌گیرید و پی‌گیرانتان به کاربران دیگر در نمایه‌تان. افراد همچنان قادرند ببینند که پی می‌گیریدشان یا نه.",
  "account_edit.profile_tab.show_relations.title": "نمایش «پی‌گرفتگان» و «پی‌گیرندگان»",
  "account_edit.profile_tab.subtitle": "سفارشی‌سازیچگونگی نمایش نماگرتان.",
  "account_edit.profile_tab.title": "تنظیمات نمایش نماگر",
  "account_edit.save": "ذخیره",
  "account_edit.upload_modal.back": "بازگشت",
  "account_edit.upload_modal.done": "انجام شد",
  "account_edit.upload_modal.next": "بعدی",
  "account_edit.upload_modal.step_crop.zoom": "بزرگنمايی",
  "account_edit.upload_modal.step_upload.button": "مرور پرونده‌ها",
  "account_edit.upload_modal.step_upload.dragging": "انداختن برای بارگذاری",
  "account_edit.upload_modal.step_upload.header": "گزینش تصویر",
  "account_edit.upload_modal.step_upload.hint": "قالب WEBP، ‏PNG، ‏GIF یا JPG تا {limit}م‌ب.{br}تصویر به {width}×{height}تص مقیاس خواهد شد.",
  "account_edit.upload_modal.title_add.avatar": "افزودن عکس نماگر",
  "account_edit.upload_modal.title_add.header": "افزودن عکس پوششی",
  "account_edit.upload_modal.title_replace.avatar": "جایگزینی عکس نمایه",
  "account_edit.upload_modal.title_replace.header": "جایگزینی عکس پوششی",
  "account_edit.verified_modal.details": "افزودن اعتبار به نماگر ماستودونتان با تأیید کردن پیوندها به پایگاه‌های وب شخصیتان. چگونگی کارکرد:",
  "account_edit.verified_modal.invisible_link.details": "افزودن پیوند به پایگاه وبتان. بخش مهم rel=\"me\" است که از جعل هویت روی پایگاه‌هایی با محتوای تولید شده به دست کاربر جلوگیری می‌کند. حتا می‌توانید به جای {tag} از برچسب link در سرایند صفحه استفاده کنید؛ ولی HTML باید بدون اجرای جاوااسکریپت در دسترس باشد.",
  "account_edit.verified_modal.invisible_link.summary": "چگونه پیوند را نامریی کنم؟",
  "account_edit.verified_modal.step1.header": "رونوشت از کد HTML زیر و چایگذاری در سرایند پایگاه وبتان",
  "account_edit.verified_modal.step2.details": "اگر پایگاه وبتان را از پیش به عنوان زمینهٔ سفارشی افزوده‌اید باید برای تأیید شدن حذفش کرده و دوباره بیفزایید.",
  "account_edit.verified_modal.step2.header": "افزودن پایگاه وبتان به عنوان زمینهٔ سفارشی",
  "account_edit.verified_modal.title": "چگونگی افزودن پیوند تأیید شده",
  "account_edit_tags.add_tag": "افزودن #{tagName}",
  "account_edit_tags.column_title": "ویرایش برچسب‌ها",
  "account_edit_tags.help_text": "برچسب‌های منتخب به کاربران در کشف و تعامل با نماگرتان کمک می‌کند. به شکل پالایه‌هایی روی نمای فعّالیت صفحهٔ نماگرتان ظاهر می‌شوند.",
  "account_edit_tags.max_tags_reached": "به بیشینهٔ تعداد برچسب‌های منتخب رسیدید.",
  "account_edit_tags.search_placeholder": "ورود برچسب…",
  "account_edit_tags.suggestions": "پیشنهادها:",
  "account_edit_tags.tag_status_count": "{count, plural, one {# فرسته} other {# فرسته}}",
  "account_list.hidden_notice": "تنها برای شما نمایان است. رفتن به <link>‫{page} > {modal} > {field}‬</link> برای نمایش این سیاهه به دیگران.",
  "account_list.total": "{total, plural, one {# حساب} other {# حساب}}",
  "account_note.placeholder": "برای افزودن یادداشت کلیک کنید",
  "admin.dashboard.daily_retention": "نرخ حفظ کاربر در روز پس از ثبت نام",
  "admin.dashboard.monthly_retention": "نرخ حفظ کاربر در ماه پس از ثبت نام",
  "admin.dashboard.retention.average": "میانگین",
  "admin.dashboard.retention.cohort": "ماه ثبت‌نام",
  "admin.dashboard.retention.cohort_size": "کاربران جدید",
  "admin.impact_report.instance_accounts": "حساب‌هایی که این کار نمایه‌شان را حدف خواهد کرد",
  "admin.impact_report.instance_followers": "پی‌گیرانی که کاربرانمان از دست خواهند داد",
  "admin.impact_report.instance_follows": "پی‌گیرانی که کاربرانشان از دست خواهند داد",
  "admin.impact_report.title": "خلاصهٔ تأثیر",
  "alert.rate_limited.message": "لطفاً پس از {retry_time, time, medium} دوباره بیازمایید.",
  "alert.rate_limited.title": "محدودیت تعداد",
  "alert.unexpected.message": "خطایی غیرمنتظره رخ داد.",
  "alert.unexpected.title": "ای وای!",
  "alt_text_badge.title": "متن جایگزین",
  "alt_text_modal.add_alt_text": "افزودن متن جایگزین",
  "alt_text_modal.add_text_from_image": "افزودن متن از عکس",
  "alt_text_modal.cancel": "لغو",
  "alt_text_modal.change_thumbnail": "تغییر بندانگشتی",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "شرح برای افرادی با مشکلات شنوایی…",
  "alt_text_modal.describe_for_people_with_visual_impairments": "شرح برای افرادی با مشکلات بینایی…",
  "alt_text_modal.done": "انجام شد",
  "announcement.announcement": "اعلامیه",
  "annual_report.announcement.action_build": "ساخت خلاصهٔ ماستودونم",
  "annual_report.announcement.action_dismiss": "نه، ممنون",
  "annual_report.announcement.action_view": "دیدن خلاصهٔ ماستودونم",
  "annual_report.announcement.description": "کشف بیش‌تر دربارهٔ درگیریتان روی ماستودون در سال گذشته.",
  "annual_report.announcement.title": "خلاصهٔ ماستودون {year} این‌جاست",
  "annual_report.nav_item.badge": "جدید",
  "annual_report.shared_page.donate": "اعانه",
  "annual_report.shared_page.footer": "ساخته شده با {heart} به دست گروه ماستودون",
  "annual_report.shared_page.footer_server_info": "‏{username} از {domain}، یکی از بسیار اجتماع قدرت گرفته به دست ماستودون استفاده می‌کند.",
  "annual_report.summary.archetype.booster.desc_public": "‏{name} در کمین فرسته‌هایی برای تقویت و کمک به دیگر تولیدکنندگان است.",
  "annual_report.summary.archetype.booster.desc_self": "در کمین فرسته‌هایی برای تقویت و کمک به دیگر تولیدکنندگان هستید.",
  "annual_report.summary.archetype.booster.name": "کماندار",
  "annual_report.summary.archetype.die_drei_fragezeichen": "؟؟؟",
  "annual_report.summary.archetype.lurker.desc_public": "می‌دانیم {name} آن‌جا بود؛ جایی در حال لذّت بردن از ماستودون به روش خاص خودش.",
  "annual_report.summary.archetype.lurker.desc_self": "می‌دانیم آن‌جا بودید؛ جایی در حال لذّت بردن از ماستودون به روش خاص خودتان.",
  "annual_report.summary.archetype.lurker.name": "رواقی",
  "annual_report.summary.archetype.oracle.desc_public": "فرسته‌های جدید {name} بیش از پاسخ‌هایش بود که ماستودون را تازه و رو به آینده نگه می‌دارد.",
  "annual_report.summary.archetype.oracle.desc_self": "فرسته‌های جدیدتان بیش از پاسخ‌هایتان بود که ماستودون را تازه و رو به آینده نگه می‌دارد.",
  "annual_report.summary.archetype.oracle.name": "پیشگو",
  "annual_report.summary.archetype.pollster.desc_public": "نظرسنجی‌های {name} بیش از دیگر فرسته‌هایش بود که حس کنجکاوی را روی ماستودون پراکند.",
  "annual_report.summary.archetype.pollster.desc_self": "نظرسنجی‌هایتان بیش از دیگر فرسته‌هایتان بود که حس کنجکاوی را روی ماستودون پراکند.",
  "annual_report.summary.archetype.pollster.name": "پرسه‌زن",
  "annual_report.summary.archetype.replier.desc_public": "‏{name} بسیار به فرسته‌های دیگران پاسخ داد که ماستودون را با بحث‌های جدید پربار کرد.",
  "annual_report.summary.archetype.replier.desc_self": "بسیار به فرسته‌های دیگران پاسخ دادید که ماستودون را با بحث‌های جدید پربار کرد.",
  "annual_report.summary.archetype.replier.name": "پروانه",
  "annual_report.summary.archetype.reveal": "آشکار سازی کهن‌الگویم",
  "annual_report.summary.archetype.reveal_description": "سپاس برای بخشی از ماستودون بود! زمانش رسیده که دریابید در کدام کهن‌الگوی {year} جا می‌گیرید.",
  "annual_report.summary.archetype.title_public": "کهن‌الگوی {name}",
  "annual_report.summary.archetype.title_self": "کهن‌الگویتان",
  "annual_report.summary.close": "بستن",
  "annual_report.summary.copy_link": "رونوشت از پیوند",
  "annual_report.summary.followers.new_followers": "{count, plural, one {پی‌گیر جدید} other {پی‌گیران جدید}}",
  "annual_report.summary.highlighted_post.boost_count": "این فرسته {count, plural, one {یک} other {#}} بار تقویت شده.",
  "annual_report.summary.highlighted_post.favourite_count": "این فرسته {count, plural, one {یک} other {#}} بار برگزیده شده.",
  "annual_report.summary.highlighted_post.reply_count": "این فرسته {count, plural, one {یک} other {#}} پاسخ گرفته.",
  "annual_report.summary.highlighted_post.title": "محبوب‌ترین فرسته",
  "annual_report.summary.most_used_app.most_used_app": "پراستفاده‌ترین کاره",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "پراستفاده‌ترین برچسب",
  "annual_report.summary.most_used_hashtag.used_count": "این برچسب را در {count, plural, one {یک} other {#}}فرسته به کار برده‌اید.",
  "annual_report.summary.most_used_hashtag.used_count_public": "‏{name} این برچسب را در {count, plural, one {یک} other {#}}فرسته به کار برده.",
  "annual_report.summary.new_posts.new_posts": "فرستهٔ جدید",
  "annual_report.summary.percentile.text": "<topLabel>بین کاربران {domain} جزو</topLabel><percentage></percentage><bottomLabel>برتر هستید.</bottomLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": "به برنی خبر نمی‌دهیم.",
  "annual_report.summary.share_elsewhere": "هم‌رسانی در جایی دیگر",
  "annual_report.summary.share_message": "من کهن‌الگوی {archetype} را گرفتم!",
  "annual_report.summary.share_on_mastodon": "هم‌رسانی روی ماستودون",
  "attachments_list.unprocessed": "(پردازش نشده)",
  "audio.hide": "نهفتن صدا",
  "block_modal.remote_users_caveat": "از کارساز {domain} خواهیم خواست که به تصمیمتان احترام بگذارد. با این حال تضمینی برای رعایتش وجود ندارد؛ زیرا برخی کارسازها ممکن است مسدودی را متفاوت مدیریت کنند. ممکن است فرسته‌های عمومی همچنان برای کاربران وارد نشده نمایان باشند.",
  "block_modal.show_less": "نمایش کم‌تر",
  "block_modal.show_more": "نمایش بیش‌تر",
  "block_modal.they_will_know": "می‌تواند ببینند که مسدود شده.",
  "block_modal.title": "انسداد کاربر؟",
  "boost_modal.combo": "دکمهٔ {combo} را بزنید تا دیگر این را نبینید",
  "boost_modal.reblog": "تقویت فرسته؟",
  "boost_modal.undo_reblog": "ناتقویت فرسته؟",
  "bundle_column_error.copy_stacktrace": "رونوشت از گزارش خطا",
  "bundle_column_error.error.body": "صفحهٔ درخواستی نتوانست پرداخت شود. ممکن است به خاطر اشکالی در کدمان یا مشکل سازگاری مرورگر باشد.",
  "bundle_column_error.error.title": "وای، نه!",
  "bundle_column_error.network.body": "هنگام تلاش برای بار کردن این صفحه خطایی رخ داد. ممکن است مشکلی موقّتی در این کارساز یا اینترنتتان باشد.",
  "bundle_column_error.network.title": "خطای شبکه",
  "bundle_column_error.retry": "تلاش دوباره",
  "bundle_column_error.return": "بازگشت به خانه",
  "bundle_column_error.routing.body": "صفحهٔ درخواستی پیدا نشد. مطمئنید که نشانی را درست وارد کرده‌اید؟",
  "bundle_column_error.routing.title": "۴۰۴",
  "bundle_modal_error.close": "بستن",
  "bundle_modal_error.message": "هنگام بار کردن این صفحه، اشتباهی رخ داد.",
  "bundle_modal_error.retry": "تلاش دوباره",
  "callout.dismiss": "رد کردن",
  "carousel.current": "<sr>پردهٔ</sr> {current, number} از {max, number}",
  "carousel.slide": "پردهٔ {current, number} از {max, number}",
  "character_counter.recommended": "{currentLength} از {maxLength} نویسهٔ پیشنهادی",
  "character_counter.required": "{currentLength} از {maxLength} نویسه",
  "closed_registrations.other_server_instructions": "از آن‌جا که ماستودون نامتمرکز است، می‌توانید حسابی روی کارسازی دیگر ساخته و همچنان با این‌یکی در تعامل باشید.",
  "closed_registrations_modal.description": "هم‌اکنون امکان ساخت حساب روی {domain} وجود ندارد؛ ولی لطفاً به خاطر داشته باشید که برای استفاده از ماستودون، نیازی به داشتن حساب روی {domain} نیست.",
  "closed_registrations_modal.find_another_server": "یافتن کارسازی دیگر",
  "closed_registrations_modal.preamble": "ماستودون نامتمرکز است، پس بدون توجّه یه جایی که حسابتان را ساخته‌اید، خواهید توانست هرکسی روی این کارساز را پی‌گرفته و با او تعامل کنید. حتا می‌توانید خودمیزبانیش کنید!",
  "closed_registrations_modal.title": "ثبت‌نام روی ماستودون",
  "collection.share_modal.share_link_label": "هم‌رسانی پیوند",
  "collection.share_modal.share_via_post": "فرستادن روی ماستودون",
  "collection.share_modal.share_via_system": "هم‌رسانی در…",
  "collection.share_modal.title": "هم‌رسانی مجموعه",
  "collection.share_modal.title_new": "هم‌رسانی مجموعهٔ جدیدتان!",
  "collection.share_template_other": "این مجموعهٔ باحال رو ببینید: {link}",
  "collection.share_template_own": "مجموعهٔ جدیدم رو ببینید: {link}",
  "collections.account_count": "{count, plural, one {# حساب} other {# حساب}}",
  "collections.accounts.empty_description": "افزودن تا {count} حساب",
  "collections.accounts.empty_editor_title": "هنوز کسی در این مجموعه نیست",
  "collections.accounts.empty_title": "این مجموعه خالیست",
  "collections.block_collection_owner": "مسدود کردن حساب",
  "collections.by_account": "از {account_handle}",
  "collections.collection_description": "شرح",
  "collections.collection_language": "زبان",
  "collections.collection_language_none": "هیچ‌کدام",
  "collections.collection_name": "نام",
  "collections.collection_topic": "موضوع",
  "collections.confirm_account_removal": "مطمئنید که می‌خواهید این حساب را از این مجموعه بردارید؟",
  "collections.content_warning": "هشدار محتوا",
  "collections.continue": "ادامه",
  "collections.copy_link": "رونوشت از پیوند",
  "collections.copy_link_confirmation": "پیوند مجموعه در تخته‌گیره رونوشت شد",
  "collections.create.accounts_title": "چه کسانی را در این مجموعه معرّفی خواهید کرد؟",
  "collections.create.basic_details_title": "جزییات پایه",
  "collections.create.steps": "گام {step} از {total}",
  "collections.create_collection": "ایجاد مجموعه",
  "collections.delete_collection": "حذف مجموعه",
  "collections.description_length_hint": "بیشینه ۱۰۰ نویسه",
  "collections.detail.author_added_you_on_date": "‫{author} در {date} افزودتان",
  "collections.detail.loading": "بار کردن مجموعه…",
  "collections.detail.revoke_inclusion": "حذفم کن",
  "collections.detail.sensitive_content": "محتوای حسّاس",
  "collections.detail.sensitive_note": "این مجموعه شامل حساب‌ها و محتواییست که ممکن است برای برخی کاربران حسّاس باشند.",
  "collections.detail.share": "هم‌رسانی این مجموعه",
  "collections.detail.you_are_in_this_collection": "در این مجموعه معرّفی شده‌اید",
  "collections.edit_details": "ویرایش جزییات",
  "collections.error_loading_collections": "هنگام تلاش برای بار کردن این مجموعه‌ها خطایی رخ داد.",
  "collections.hidden_accounts_description": "{count, plural, one {این کاربر} other {این کاربران}} را مسدود کرده‌اید",
  "collections.hidden_accounts_link": "{count, plural, one {# حساب نهفته} other {# حساب نهفته}}",
  "collections.hints.accounts_counter": "{count} از {max} حساب",
  "collections.last_updated_at": "آخرین به‌روز رسانی: {date}",
  "collections.list.collections_with_count": "{count, plural, one {# مجموعه} other {# مجموعه}}",
  "collections.list.created_by_author": "ایجاد شده به دست {name}",
  "collections.list.created_by_you": "ایجاد شده به دست شما",
  "collections.list.featuring_you": "شما را معرّفی می‌کند",
  "collections.manage_accounts": "مدیریت حساب‌ها",
  "collections.mark_as_sensitive": "علامت به حسّاس",
  "collections.mark_as_sensitive_hint": "نهفتن شرح مجموعه و حساب‌ها پشت هشدار محتوا. نام مجموعه همچنان نمایان خواهد بود.",
  "collections.maximum_collection_count_description": "کارسازتان اجازه ایجاد تا {count} مجموعه را می‌دهد.",
  "collections.maximum_collection_count_reached": "بیشینهٔ تعداد مجموعه‌ها را ساخته‌اید",
  "collections.name_length_hint": "بیشینه ۴۰ نویسه",
  "collections.new_collection": "مجموعهٔ جدید",
  "collections.pending_accounts.message": "ممکن است هنگام انتظارمان برای پاسخ از سوی کاربر یا کارسازش حساب‌ها به عنوان منتظر ظاهر شوند. تنها شما می‌توانید حساب‌های منتظر را ببینید.",
  "collections.pending_accounts.title": "چرا حساب‌های منتظر را می‌بینم؟",
  "collections.remove_account": "برداشتن",
  "collections.report_collection": "گزارش این مجموعه",
  "collections.revoke_collection_inclusion": "برداشتن خودم از این مجموعه",
  "collections.revoke_inclusion.confirmation": "از «{collection}» برداشته شدید",
  "collections.revoke_inclusion.error": "خطایی رخ داد. لطفاً بعداً دوباره تلاش کنید.",
  "collections.search_accounts_label": "جست‌وجوی حسابی برای افزودن",
  "collections.search_accounts_max_reached": "بیشینهٔ تعداد حساب‌ها را افزوده‌اید",
  "collections.sensitive": "حسّاس",
  "collections.share_short": "هم‌رسانی",
  "collections.suggestions.can_not_add": "نمی‌توان افزود",
  "collections.suggestions.can_not_add_desc": "ممکن است این حساب‌ها از کشف خارج شده باشند یا روی کارسازی باشند که از مجموعه‌ها پشتیبانی نمی‌کند.",
  "collections.suggestions.must_follow": "نخست باید پی بگیرید",
  "collections.suggestions.must_follow_desc": "این حساب‌ها همهٔ درخواست‌های پی‌گیری را بازبینی می‌کنند. پی‌گیرندگان می‌توانند به مجموعه‌ها بیفزایندشان.",
  "collections.topic_hint": "افوزدن برچسبی که به دیگران در فهم موضوع این مجموعه کمک می‌کند.",
  "collections.topic_special_chars_hint": "نویسه‌های ویژه هنگام ذخیره کردن برداشته خواهند شد",
  "collections.unlisted_collections_description": "این‌ها برای دیگران روی نماگرتان ظاهر نخواهد شد. هرکسی با پیوند می‌تواند کشفشان کند.",
  "collections.unlisted_collections_with_count": "مجموعه‌های سیاهه نشده ({count})",
  "collections.view_collection": "دیدن مجموعه",
  "collections.visibility_public": "عمومی",
  "collections.visibility_public_hint": "قابل کشف در نتیجه‌های جست‌وجو و دیگر نواحی‌ای که توصیه‌ها ظاهر می‌شوند.",
  "collections.visibility_title": "نمایانی",
  "collections.visibility_unlisted": "فهرست نشده",
  "collections.visibility_unlisted_hint": "نمایان برای هرکسی با پیوند. نهفته از نتیجه‌های جست‌وجو و توصیه‌ها.",
  "column.about": "درباره",
  "column.blocks": "کاربران مسدود شده",
  "column.bookmarks": "نشانک‌ها",
  "column.community": "خط زمانی محلی",
  "column.create_list": "ایجاد سیاهه",
  "column.direct": "اشاره‌های خصوصی",
  "column.directory": "مرور نمایه‌ها",
  "column.domain_blocks": "دامنه‌های مسدود شده",
  "column.edit_list": "ویرایش سیاهه",
  "column.favourites": "برگزیده‌ها",
  "column.firehose": "خوراک‌های زنده",
  "column.firehose_local": "خوراک زندهٔ این کارساز",
  "column.firehose_singular": "خوراک زنده",
  "column.follow_requests": "درخواست‌های پی‌گیری",
  "column.home": "خانه",
  "column.list_members": "مدیریت اعضای سیاهه",
  "column.lists": "سیاهه‌ها",
  "column.mutes": "کاربران خموش",
  "column.notifications": "آگاهی‌ها",
  "column.other_collections": "محموعه‌های {name}",
  "column.pins": "فرسته‌های سنجاق شده",
  "column.public": "خط زمانی همگانی",
  "column.your_collections": "مجموعه‌هایتان",
  "column_back_button.label": "بازگشت",
  "column_header.hide_settings": "نهفتن تنظیمات",
  "column_header.moveLeft_settings": "جابه‌جایی ستون به چپ",
  "column_header.moveRight_settings": "جابه‌جایی ستون به راست",
  "column_header.pin": "سنجاق کردن",
  "column_header.show_settings": "نمایش تنظیمات",
  "column_header.unpin": "برداشتن سنجاق",
  "column_search.cancel": "لغو",
  "combobox.close_results": "بستن نتیجه‌ها",
  "combobox.loading": "بار کردن",
  "combobox.no_results_found": "این جست‌وجو هیچ نتیجه‌ای نداشت",
  "combobox.open_results": "گشودن نتیجه‌ها",
  "combobox.results_available": "‫{count, plural, one {# پیشنهاد} other {# پیشنهاد}} موجود است. استفاده از کلیدهای جهت‌دار بالا و پایین برای پیمایش. زدن کلید ورود برای گزینش.",
  "community.column_settings.local_only": "فقط محلی",
  "community.column_settings.media_only": "فقط رسانه",
  "community.column_settings.remote_only": "تنها دوردست",
  "compose.error.blank_post": "فرسته نمی‌تواند خالی باشد.",
  "compose.language.change": "تغییر زبان",
  "compose.language.search": "جست‌وجوی زبان‌ها...",
  "compose.published.body": "فرسته منتشر شد.",
  "compose.published.open": "گشودن",
  "compose.saved.body": "فرسته ذخیره شد.",
  "compose_form.direct_message_warning_learn_more": "بیشتر بدانید",
  "compose_form.encryption_warning": "فرسته‌های ماستودون رمزگذاری سرتاسری نشده‌اند. هیچ اطّلاعات حساسی را روی ماستودون هم‌رسانی نکنید.",
  "compose_form.hashtag_warning": "از آن‌جا که این فرسته عمومی نیست زیر هیچ برچسبی سیاهه نخواهد شد. تنها فرسته‌های عمومی می‌توانند با برچسب جست‌وجو شوند.",
  "compose_form.lock_disclaimer": "حسابتان {locked} نیست. هر کسی می‌تواند پی‌گیرتان شده و فرسته‌های ویژهٔ پی‌گیرانتان را ببیند.",
  "compose_form.lock_disclaimer.lock": "قفل‌شده",
  "compose_form.placeholder": "تازه چه خبر؟",
  "compose_form.poll.duration": "مدت نظرسنجی",
  "compose_form.poll.multiple": "چند گزینه‌ای",
  "compose_form.poll.option_placeholder": "گزینهٔ {number}",
  "compose_form.poll.single": "تک گزینه‌ای",
  "compose_form.poll.switch_to_multiple": "تغییر نظرسنجی برای اجازه به چندین گزینه",
  "compose_form.poll.switch_to_single": "تبدیل به نظرسنجی تک‌گزینه‌ای",
  "compose_form.poll.type": "سبک",
  "compose_form.publish": "فرستادن",
  "compose_form.reply": "پاسخ",
  "compose_form.save_changes": "به‌روز رسانی",
  "compose_form.spoiler.marked": "برداشتن هشدار محتوا",
  "compose_form.spoiler.unmarked": "افزودن هشدار محتوا",
  "compose_form.spoiler_placeholder": "هشدار محتوا (اختیاری)",
  "confirmation_modal.cancel": "لغو",
  "confirmations.block.confirm": "انسداد",
  "confirmations.delete.confirm": "حذف",
  "confirmations.delete.message": "آیا مطمئنید که می‌خواهید این فرسته را حذف کنید؟",
  "confirmations.delete.title": "حذف فرسته؟",
  "confirmations.delete_collection.confirm": "حذف",
  "confirmations.delete_collection.message": "این کنش بازگشت‌پذیر نیست.",
  "confirmations.delete_collection.title": "حذف «{name}»؟",
  "confirmations.delete_list.confirm": "حذف",
  "confirmations.delete_list.message": "مطمئنید می‌خواهید این سیاهه را برای همیشه حذف کنید؟",
  "confirmations.delete_list.title": "حذف سیاهه؟",
  "confirmations.discard_draft.confirm": "دور انداختن و ادامه",
  "confirmations.discard_draft.edit.cancel": "ادامهٔ ویرایش",
  "confirmations.discard_draft.edit.message": "ادامه دادن هر تغییری که روی فرستهٔ در حال ویرایش داده‌اید را دور خواهد ریخت.",
  "confirmations.discard_draft.edit.title": "دور ریختن تغییرات فرسته‌تان؟",
  "confirmations.discard_draft.post.cancel": "از سر گیری پیش‌نویس",
  "confirmations.discard_draft.post.message": "ادامه دادن باعث دور ریخته شدن تغییرات روی فرسته‌ای که دارید می‌نویسید خواهد شد.",
  "confirmations.discard_draft.post.title": "دور ریختن فرستهٔ پیش‌نویستان؟",
  "confirmations.discard_edit_media.confirm": "دور انداختن",
  "confirmations.discard_edit_media.message": "تغییرات ذخیره نشده‌ای در توضیحات یا پیش‌نمایش رسانه دارید. همگی نادیده گرفته شوند؟",
  "confirmations.follow_to_list.confirm": "پی‌گیری و افزودن به سیاهه",
  "confirmations.follow_to_list.message": "برای افزودن {name} به سیاهه باید پیش گرفته باشید.",
  "confirmations.follow_to_list.title": "پی‌گیری کاربر؟",
  "confirmations.hide_featured_tab.confirm": "نهفتن زبانه",
  "confirmations.hide_featured_tab.title": "نهفتن زبانهٔ «معرّفی شده»؟",
  "confirmations.logout.confirm": "خروج از حساب",
  "confirmations.logout.message": "مطمئنید می‌خواهید خارج شوید؟",
  "confirmations.logout.title": "خروج؟",
  "confirmations.missing_alt_text.confirm": "متن جایگزین را اضافه کنید",
  "confirmations.missing_alt_text.message": "فرسته‌تان رسانه‌هایی بدون متن جایگزین دارد. افزودن شرح به دسترس‌پذیر شدن محتوایتان برای افراد بیش‌تری کمک می‌کند.",
  "confirmations.missing_alt_text.secondary": "به هر حال پست کن",
  "confirmations.missing_alt_text.title": "متن جایگزین اضافه شود؟",
  "confirmations.mute.confirm": "خموش",
  "confirmations.private_quote_notify.cancel": "بازگشت به ویرایش کردن",
  "confirmations.private_quote_notify.confirm": "انتشار فرسته",
  "confirmations.private_quote_notify.do_not_show_again": "دیگر این پیام نشان داده نشود",
  "confirmations.private_quote_notify.message": "فردی که نقلش می‌کنید و کسانی که اشاره شده‌اند آگاه خواهند شد و می‌توانند فرسته‌تان را ببینند؛ حتا اگر پیتان نگیرند.",
  "confirmations.private_quote_notify.title": "هم‌رسانی با پی‌گیرندگان و کاربران اشاره شده؟",
  "confirmations.quiet_post_quote_info.dismiss": "دیگر یادآوری نشود",
  "confirmations.quiet_post_quote_info.got_it": "گرفتم",
  "confirmations.quiet_post_quote_info.message": "هنگام نقل کردن فرستهٔ عمومی ساکت، فرسته‌تان از خط‌های زمانی داغ پنهان خواهد بود.",
  "confirmations.quiet_post_quote_info.title": "نقل کردن فرسته‌های عمومی ساکت",
  "confirmations.redraft.confirm": "حذف و بازنویسی",
  "confirmations.redraft.message": "مطمئنید که می‌خواهید این فرسته را حذف کنید و از نو بنویسید؟ با این کار تقویت‌ها و پسندهایش از دست رفته و پاسخ‌ها به آن بی‌مرجع می‌شود.",
  "confirmations.redraft.title": "حذف و پیش‌نویسی دوبارهٔ فرسته؟",
  "confirmations.remove_from_followers.confirm": "برداشتن پی‌گیرنده",
  "confirmations.remove_from_followers.message": "دیگر {name} پیتان نخواهد گرفت. مطمئنید که می‌خواهید ادامه دهید؟",
  "confirmations.remove_from_followers.title": "برداشتن پی‌گیرنده؟",
  "confirmations.revoke_collection_inclusion.confirm": "حذفم کن",
  "confirmations.revoke_collection_inclusion.title": "برداشتن خودتان از این مجموعه؟",
  "confirmations.revoke_quote.confirm": "حذف فرسته",
  "confirmations.revoke_quote.message": "این اقدام قابل بازگشت نیست.",
  "confirmations.revoke_quote.title": "آیا فرسته را حذف کنم؟",
  "confirmations.unblock.confirm": "رفع انسداد",
  "confirmations.unblock.title": "رفع انسداد {name}؟",
  "confirmations.unfollow.confirm": "پی‌نگرفتن",
  "confirmations.unfollow.title": "ناپی‌گیری {name}؟",
  "confirmations.withdraw_request.confirm": "انصراف از درخواست",
  "confirmations.withdraw_request.title": "انصراف از درخواست پی‌گیری {name}؟",
  "content_warning.hide": "نهفتن فرسته",
  "content_warning.show": "در هر صورت نشان داده شود",
  "content_warning.show_more": "نمایش بیش‌تر",
  "content_warning.show_short": "نمایش",
  "conversation.delete": "حذف گفتگو",
  "conversation.mark_as_read": "علامت‌گذاری به عنوان خوانده شده",
  "conversation.open": "دیدن گفتگو",
  "conversation.with": "با {names}",
  "copy_icon_button.copied": "در بریده‌دان رونوشت شد",
  "copy_icon_button.copy_this_text": "رونوشت از پیوند در تخته‌گیره",
  "copypaste.copied": "رونوشت شد",
  "copypaste.copy_to_clipboard": "رونوشت به تخته‌گیره",
  "directory.federated": "از کارسازهای شناخته‌شده",
  "directory.local": "تنها از {domain}",
  "directory.new_arrivals": "تازه‌واردان",
  "directory.recently_active": "کاربران فعال اخیر",
  "disabled_account_banner.account_settings": "تنظیمات حساب",
  "disabled_account_banner.text": "حسابتان {disabledAccount} اکنون از کار افتاده.",
  "dismissable_banner.community_timeline": "این‌ها جدیدترین فرسته‌های عمومی از افرادیند که حساب‌هایشان به دست {domain} میزبانی می‌شود.",
  "dismissable_banner.dismiss": "دور انداختن",
  "dismissable_banner.public_timeline": "این‌ها جدیدترین فرسته‌های عمومی از افرادی روی وب اجتماعیند که اعضای {domain} پی می‌گیرندشان.",
  "domain_block_modal.block": "انسداد کارساز",
  "domain_block_modal.block_account_instead": "انسداد @{name} به جایش",
  "domain_block_modal.they_can_interact_with_old_posts": "افزارد روی این کارساز می‌توانند با فرسته‌های قدیمیتان تعامل داشته باشند.",
  "domain_block_modal.they_cant_follow": "هیچ‌کسی از این کارساز نمی‌تواند پیتان بگیرد.",
  "domain_block_modal.they_wont_know": "نخواهد دانست که مسدود شده.",
  "domain_block_modal.title": "انسداد دامنه؟",
  "domain_block_modal.you_will_lose_num_followers": "شما {followersCount, plural, one {{followersCountDisplay} پی‌گیرنده} other {{followersCountDisplay} پی‌گیرنده}} و {followingCount, plural, one {{followingCountDisplay} فرد پی‌گرفته‌شده} other {{followingCountDisplay} فرد پی‌گرفته‌شده}} را از دست خواهید داد.",
  "domain_block_modal.you_will_lose_relationships": "شما تمام پیگیرکنندگان و افرادی که از این کارساز پیگیری می‌کنید را از دست خواهید داد.",
  "domain_block_modal.you_wont_see_posts": "فرسته‌ها یا آگاهی‌ها از کاربران روی این کارساز را نخواهید دید.",
  "domain_pill.activitypub_lets_connect": "این به شما اجازه می‌دهد تا نه تنها در ماستودون، بلکه در برنامه‌های اجتماعی مختلف نیز با افراد ارتباط برقرار کرده و تعامل داشته باشید.",
  "domain_pill.activitypub_like_language": "ActivityPub مانند زبانی است که ماستودون با دیگر شبکه‌های اجتماعی صحبت می‌کند.",
  "domain_pill.server": "کارساز",
  "domain_pill.their_handle": "شناسه‌اش:",
  "domain_pill.their_server": "خانهٔ رقمیش. جایی که همهٔ فرسته‌هایش می‌زیند.",
  "domain_pill.their_username": "شناسهٔ یکتایش در کارسازش. ممکن است کاربرانی با نام کاربری مشابه روی کارسازهای مختلف باشند.",
  "domain_pill.username": "نام کاربری",
  "domain_pill.whats_in_a_handle": "شناسه چیست؟",
  "domain_pill.who_they_are": "از آن‌جا که شناسه‌ها کیستی و کجایی افراد را می‌گویند، می‌توانید با افرادی در سراسر وب اجتماعی <button>بن‌سازه‌های قدرت گرفته از اکتیویتی پاپ</button> تعامل داشته باشید.",
  "domain_pill.who_you_are": "از آن‌جا که شناسه‌ها کیستی و کجاییتان را می‌گویند، افراد می‌توانند از سراسر وب اجتماعی <button>بن‌سازه‌های قدرت گرفته از اکتیویتی پاپ</button> با شما تعامل داشته باشند.",
  "domain_pill.your_handle": "شناسه‌تان:",
  "domain_pill.your_server": "خانهٔ رقمیتان. جایی که همهٔ فرسته‌هایتان می‌زیند. دوستش ندارید؟ در هر زمان کارسازتان را جابه‌جا کرده و پی‌گیرندگانتان را نیز بیاورید.",
  "domain_pill.your_username": "شناسهٔ یکتایتان روی این کارساز. ممکن است کاربرانی با نام کاربری مشابه روی کارسازهای دیگر باشند.",
  "dropdown.empty": "انتخاب یک گزینه",
  "email_subscriptions.email": "رایانامه",
  "email_subscriptions.form.action": "اشتراک",
  "email_subscriptions.submitted.title": "یک گام دیگر",
  "email_subscriptions.validation.email.blocked": "فراهم کنندهٔ رایانامهٔ مسدود",
  "email_subscriptions.validation.email.invalid": "نشانی رایانامه نامعتبر",
  "embed.instructions": "جاسازی این فرسته روی پایگاهتان با رونوشت کردن کد زیر.",
  "embed.preview": "این گونه دیده خواهد شد:",
  "emoji_button.activity": "فعالیت",
  "emoji_button.clear": "پاک سازی",
  "emoji_button.custom": "سفارشی",
  "emoji_button.flags": "پرچم‌ها",
  "emoji_button.food": "غذا و نوشیدنی",
  "emoji_button.label": "افزودن شکلک",
  "emoji_button.nature": "طبیعت",
  "emoji_button.not_found": "شکلک منطبقی یافت نشد",
  "emoji_button.objects": "اشیا",
  "emoji_button.people": "مردم",
  "emoji_button.recent": "پراستفاده",
  "emoji_button.search": "جست‌وجو...",
  "emoji_button.search_results": "نتایج جست‌وجو",
  "emoji_button.symbols": "نمادها",
  "emoji_button.travel": "سفر و مکان",
  "empty_column.account_featured.other": "‫{acct} هنوز چیزی را معرّفی نکرده.",
  "empty_column.account_featured_self.no_collections_button": "ایجاد مجموعه",
  "empty_column.account_featured_self.no_collections_hide_tab": "نهفتن این زبانه",
  "empty_column.account_featured_self.pre_collections": "منتظر مجموعه‌ها باشید",
  "empty_column.account_featured_self.showcase_accounts": "نمایشکاه حساب‌های محبوبتان",
  "empty_column.account_featured_unknown.other": "این حساب هنوز چیزی را معرّفی نکرده.",
  "empty_column.account_hides_collections": "کاربر خواسته که این اطّلاعات در دسترس نباشند",
  "empty_column.account_suspended": "حساب معلق شد",
  "empty_column.account_timeline": "هیچ فرسته‌ای این‌جا نیست!",
  "empty_column.account_unavailable": "نمایهٔ موجود نیست",
  "empty_column.blocks": "هنوز کسی را مسدود نکرده‌اید.",
  "empty_column.bookmarked_statuses": "هنوز هیچ فرستهٔ نشانه‌گذاری شده‌ای ندارید. هنگامی که فرسته‌ای را نشانه‌گذاری کنید، این‌جا نشان داده خواهد شد.",
  "empty_column.collections.featured_in": "هنوز به هیچ مجموعه‌ای افزوده نشده‌اید.",
  "empty_column.community": "خط زمانی محلی خالیست. چیزی نوشته تا چرخش بچرخد!",
  "empty_column.direct": "هنوز هیچ اشاره خصوصی‌ای ندارید. هنگامی که چنین پیامی بگیرید یا بفرستید این‌جا نشان داده خواهد شد.",
  "empty_column.disabled_feed": "این خوراک به دست مدیران کارسازتان از کار انداخته شده.",
  "empty_column.domain_blocks": "هنوز هیچ دامنه‌ای مسدود نشده است.",
  "empty_column.explore_statuses": "الآن چیزی پرطرفدار نیست. بعداً دوباره بررسی کنید!",
  "empty_column.favourited_statuses": "شما هنوز هیچ فرسته‌ای را نپسندیده‌اید. هنگامی که فرسته‌ای را بپسندید، این‌جا نشان داده خواهد شد.",
  "empty_column.favourites": "هنوز هیچ کسی این فرسته را نپسندیده است. هنگامی که کسی آن را بپسندد، این‌جا نشان داده خواهد شد.",
  "empty_column.follow_requests": "شما هنوز هیچ درخواست پی‌گیری‌ای ندارید. هنگامی که چنین درخواستی بگیرید، این‌جا نشان داده خواهد شد.",
  "empty_column.followed_tags": "شما هیچ برچسبی را پی‌نگرفتید. هنگامی که برچسبی را پی‌گیری کنید اینجا نمایان می‌شوند.",
  "empty_column.hashtag": "هنوز هیچ چیزی در این برچسب نیست.",
  "empty_column.home": "خط زمانی خانگیتان خالی است! برای پر کردنش، افراد بیشتری را پی بگیرید.",
  "empty_column.list": "هنوز چیزی در این سیاهه نیست. هنگامی که اعضایش فرسته‌های جدیدی بفرستند، این‌جا ظاهر خواهند شد.",
  "empty_column.mutes": "هنوز هیچ کاربری را خموش نکرده‌اید.",
  "empty_column.notification_requests": "همه چیز تمیز است! هیچ‌چیزی این‌جا نیست. هنگامی که آگاهی‌های جدیدی دریافت کنید، بسته به تنظیماتتان این‌جا ظاهر خواهند شد.",
  "empty_column.notifications": "هنوز هیچ آگاهی‌ای ندارید. هنگامی که دیگران با شما برهم‌کنش داشته باشند، این‌جا خواهید دیدش.",
  "empty_column.public": "این‌جا هنوز چیزی نیست! خودتان چیزی بنویسید یا کاربران کارسازهای دیگر را پی‌گیری کنید تا این‌جا پُر شود",
  "empty_state.no_results": "بدون نتیجه",
  "error.no_hashtag_feed_access": "پیوستن یا ورود برای مشاهده و پی‌گیری این برچسب.",
  "error.unexpected_crash.explanation": "به خاطر اشکالی در کدهای ما یا ناسازگاری با مرورگر شما، این صفحه به درستی نمایش نیافت.",
  "error.unexpected_crash.explanation_addons": "این صفحه نمی‌تواند درست نشان داده شود. احتمالاً این خطا ناشی از یک افزونهٔ مرورگر یا ابزار ترجمهٔ خودکار است.",
  "error.unexpected_crash.next_steps": "لطفاً صفحه را دوباره باز کنید. اگر کمکی نکرد، شاید همچنان بتوانید با ماستودون از راه یک مرورگر دیگر یا با یکی از کاره‌های آن کار کنید.",
  "error.unexpected_crash.next_steps_addons": "لطفاً از کارشان انداخته و صفحه را نوسازی کنید. اگر کمکی نکرد، شاید همچنان بتوانید با مرورگری دیگر یا با کاره‌ای بومی از ماستودون استفاده کنید.",
  "errors.unexpected_crash.copy_stacktrace": "رونوشت از جزئیات اشکال",
  "errors.unexpected_crash.report_issue": "گزارش مشکل",
  "explore.suggested_follows": "افراد",
  "explore.title": "پرطرفدار",
  "explore.trending_links": "اخبار",
  "explore.trending_statuses": "فرسته‌ها",
  "explore.trending_tags": "برچسب‌ها",
  "featured_carousel.current": "<sr>فرستهٔ</sr> {current, number} از {max, number}",
  "featured_carousel.header": "{count, plural, one {فرسته سنجاق‌شده} other {فرسته‌های سنجاق‌شده}}",
  "featured_carousel.slide": "فرستهٔ {current, number} از {max, number}",
  "featured_tags.more_items": "+{count}",
  "featured_tags.suggestions.add": "افزودن",
  "filter_modal.added.context_mismatch_explanation": "این دستهٔ پالایه به بافتاری که در آن به این فرسته دسترسی دارید اعمال نمی‌شود. اگر می‌خواهید فرسته در این بافتار هم پالوده شود، باید پالایه را ویرایش کنید.",
  "filter_modal.added.context_mismatch_title": "بافتار نامطابق!",
  "filter_modal.added.expired_explanation": "این دستهٔ پالایه منقضی شده است. برای اعمالش باید تاریخ انقضا را عوض کنید.",
  "filter_modal.added.expired_title": "پالایهٔ منقضی!",
  "filter_modal.added.review_and_configure": "برای بازبینی و پیکربندی بیش‌تر این دستهٔ پالایه، به {settings_link} بروید.",
  "filter_modal.added.review_and_configure_title": "تنظیمات پالایه",
  "filter_modal.added.settings_link": "صفحهٔ تنظیمات",
  "filter_modal.added.short_explanation": "این فرسته به دستهٔ پالایهٔ زیر افزوده شد: {title}.",
  "filter_modal.added.title": "پالایه افزوده شد!",
  "filter_modal.select_filter.context_mismatch": "به این بافتار اعمال نمی‌شود",
  "filter_modal.select_filter.expired": "منقضی‌شده",
  "filter_modal.select_filter.prompt_new": "دستهٔ جدید: {name}",
  "filter_modal.select_filter.search": "جست‌وجو یا ایجاد",
  "filter_modal.select_filter.subtitle": "استفاده از یک دستهً موجود یا ایجاد دسته‌ای جدید",
  "filter_modal.select_filter.title": "پالایش این فرسته",
  "filter_modal.title.status": "پالایش یک فرسته",
  "filter_warning.matches_filter": "مطابق با پالایهٔ «<span>{title}</span>»",
  "filtered_notifications_banner.pending_requests": "از {count, plural, =0 {هیچ‌کسی} one {فردی} other {# نفر}} که ممکن است بشناسید",
  "filtered_notifications_banner.title": "آگاهی‌های پالوده",
  "firehose.all": "همه",
  "firehose.local": "این کارساز",
  "firehose.remote": "دیگر کارسازها",
  "follow_request.authorize": "اجازه دهید",
  "follow_request.reject": "رد کنید",
  "follow_requests.unlocked_explanation": "با این که حسابتان قفل نیست، کارکنان {domain} فکر کردند که ممکن است بخواهید درخواست‌ها از این حساب‌ها را به صورت دستی بازبینی کنید.",
  "follow_suggestions.curated_suggestion": "گزینش سردبیر",
  "follow_suggestions.dismiss": "دیگر نشان داده نشود",
  "follow_suggestions.featured_longer": "دست‌چین شده به دست گروه {domain}",
  "follow_suggestions.friends_of_friends_longer": "محبوب بین کسانی که پی‌گرفته‌اید",
  "follow_suggestions.hints.featured": "این نمایه به دست گروه {domain} دستچین شده.",
  "follow_suggestions.hints.friends_of_friends": "این نمایه بین کسانی که پی می‌گیرید محبوب است.",
  "follow_suggestions.hints.most_followed": "این نمایه روی {domain} بسیار پی‌گرفته شده.",
  "follow_suggestions.hints.most_interactions": "این نمایه اخیراُ روی {domain} توجّه زیادی گرفته.",
  "follow_suggestions.hints.similar_to_recently_followed": "این نمایه شبیه نمایه‌هاییست که اخیراً پی‌گرفته‌اید.",
  "follow_suggestions.personalized_suggestion": "پیشنهاد شخصی",
  "follow_suggestions.popular_suggestion": "پیشنهاد محبوب",
  "follow_suggestions.popular_suggestion_longer": "محبوب روی {domain}",
  "follow_suggestions.similar_to_recently_followed_longer": "شبیه نمایه‌هایی که اخیراً پی گرفته‌اید",
  "follow_suggestions.view_all": "دیدن همه",
  "follow_suggestions.who_to_follow": "افرادی برای پی‌گیری",
  "followed_tags": "برچسب‌های پی‌گرفته",
  "followers.title": "‫{name} را پی می‌گیرد",
  "following.title": "پی گرفته از سوی {name}",
  "footer.about": "درباره",
  "footer.about_mastodon": "دربارهٔ ماستودون",
  "footer.about_server": "دربارهٔ {domain}",
  "footer.about_this_server": "درباره",
  "footer.directory": "فهرست نمایه‌ها",
  "footer.get_app": "گرفتن کاره",
  "footer.keyboard_shortcuts": "میان‌برهای صفحه‌کلید",
  "footer.privacy_policy": "سیاست محرمانگی",
  "footer.source_code": "نمایش کد مبدأ",
  "footer.status": "وضعیت",
  "footer.terms_of_service": "شرایط استفاده از خدمات",
  "form_error.blank": "زمینه نمی‌تواند خالی باشد.",
  "form_field.optional": "(اختیاری)",
  "generic.saved": "ذخیره شده",
  "getting_started.heading": "آغاز کنید",
  "hashtag.admin_moderation": "گشودن میانای نظارت برای ‎#{name}",
  "hashtag.browse": "مرور فرسته‌ها در #{hashtag}",
  "hashtag.browse_from_account": "مرور فرسته‌ها از ‪@{name}‬ در #{hashtag}",
  "hashtag.column_header.tag_mode.all": "و {additional}",
  "hashtag.column_header.tag_mode.any": "یا {additional}",
  "hashtag.column_header.tag_mode.none": "بدون {additional}",
  "hashtag.column_settings.select.no_options_message": "هیچ پیشنهادی پیدا نشد",
  "hashtag.column_settings.select.placeholder": "برچسب‌ها را وارد کنید…",
  "hashtag.column_settings.tag_mode.all": "همۀ این‌ها",
  "hashtag.column_settings.tag_mode.any": "هرکدام از این‌ها",
  "hashtag.column_settings.tag_mode.none": "هیچ‌کدام از این‌ها",
  "hashtag.column_settings.tag_toggle": "افزودن برچسب‌هایی بیشتر به این ستون",
  "hashtag.counter_by_accounts": "{count, plural, one {{counter} مشارکت کننده} other {{counter} مشارکت کننده}}",
  "hashtag.counter_by_uses": "{count, plural, one {{counter} فرسته} other {{counter} فرسته}}",
  "hashtag.counter_by_uses_today": "{count, plural, one {{counter} فرسته} other {{counter} فرسته}} امروز",
  "hashtag.feature": "معرّفی در نمایه",
  "hashtag.follow": "پی‌گرفتن برچسب",
  "hashtag.mute": "خموشی #{hashtag}",
  "hashtag.unfeature": "معرّفی نکردن در نمایه",
  "hashtag.unfollow": "پی‌نگرفتن برچسب",
  "hashtags.and_other": "…و {count, plural, other {# بیش‌تر}}",
  "hints.profiles.followers_may_be_missing": "شاید پی‌گیرندگان این نمایه نباشند.",
  "hints.profiles.follows_may_be_missing": "شاید پی‌گرفته‌های این نمایه نباشند.",
  "hints.profiles.posts_may_be_missing": "شاید فرسته‌هایی از این نمایه نباشند.",
  "hints.profiles.see_more_followers": "دیدن پی‌گیرندگان بیش‌تر روی {domain}",
  "hints.profiles.see_more_follows": "دیدن پی‌گرفته‌های بیش‌تر روی {domain}",
  "hints.profiles.see_more_posts": "دیدن فرسته‌های بیش‌تر روی {domain}",
  "home.column_settings.show_quotes": "نمایش نقل‌ها",
  "home.column_settings.show_reblogs": "نمایش تقویت‌ها",
  "home.column_settings.show_replies": "نمایش پاسخ‌ها",
  "home.hide_announcements": "نهفتن اعلامیه‌ها",
  "home.pending_critical_update.body": "لطفاً کارساز ماستودونتان را در نخستین فرصت به‌روز کنید!",
  "home.pending_critical_update.link": "دیدن به‌روز رسانی‌ها",
  "home.pending_critical_update.title": "به‌روز رسانی امنیتی بحرانی موجود است!",
  "home.show_announcements": "نمایش اعلامیه‌ها",
  "ignore_notifications_modal.disclaimer": "ماستودون نمی تواند به کاربران اطلاع دهد که اعلان های آنها را نادیده گرفته اید. نادیده گرفتن اعلان ها مانع از ارسال خود پیام ها نمی شود.",
  "ignore_notifications_modal.filter_instead": "به جایش پالوده شود",
  "ignore_notifications_modal.filter_to_act_users": "همچنان می‌توانید کاربران را بپذیرید، رد کنید یا گزارش دهید",
  "ignore_notifications_modal.filter_to_avoid_confusion": "فیلتر کردن به جلوگیری از سردرگمی احتمالی کمک می کند",
  "ignore_notifications_modal.filter_to_review_separately": "می توانید اعلان های فیلتر شده را به طور جداگانه بررسی کنید",
  "ignore_notifications_modal.ignore": "چشم‌پوشی از آگاهی‌ها",
  "ignore_notifications_modal.limited_accounts_title": "چشم‌پوشی از آگاهی‌های حساب‌های نظارت شده؟",
  "ignore_notifications_modal.new_accounts_title": "چشم‌پوشی از آگاهی‌های حساب‌های جدید؟",
  "ignore_notifications_modal.not_followers_title": "چشم‌پوشی از آگاهی‌های افرادی که پیتان نمی‌گیرند؟",
  "ignore_notifications_modal.not_following_title": "چشم‌پوشی از آگاهی‌های افرادی که پیشان نمی‌گیرید؟",
  "ignore_notifications_modal.private_mentions_title": "چشم‌پوشی از نام‌بری‌های خصوصی ناخواسته؟",
  "info_button.label": "راهنما",
  "info_button.what_is_alt_text": "<h1>متن جایگزین چیست؟</h1> <p>متن جایگزین توضیحات تصویری را برای افراد دارای اختلالات بینایی، اتصالات با پهنای باند کم یا کسانی که به دنبال زمینه اضافی هستند ارائه می دهد.</p> <p>با نوشتن متن جایگزین واضح، مختصر و عینی می توانید دسترسی و درک را برای همه بهبود بخشید.</p> <ul> <li>عناصر مهم را ضبط کنید</li> <li>متن را در تصاویر خلاصه کنید</li> <li>از ساختار جمله منظم استفاده کنید</li> <li>از اطلاعات اضافی خودداری کنید</li> <li>روی روندها و یافته های کلیدی در تصاویر پیچیده (مانند نمودارها یا نقشه ها) تمرکز کنید.</li> </ul>",
  "interaction_modal.action": "برای تعامل با فرستهٔ {name} باید به حسابتان روی هر کارساز ماستودونی که استفاده می‌کنید وارد شوید.",
  "interaction_modal.go": "برو",
  "interaction_modal.no_account_yet": "هنوز حساب کاربری ندارید؟",
  "interaction_modal.on_another_server": "روی کارسازی دیگر",
  "interaction_modal.on_this_server": "روی این کارساز",
  "interaction_modal.title": "ورود برای ادامه",
  "interaction_modal.username_prompt": "به عنوان مثال {example}",
  "intervals.full.days": "{number, plural, one {# روز} other {# روز}}",
  "intervals.full.hours": "{number, plural, one {# ساعت} other {# ساعت}}",
  "intervals.full.minutes": "{number, plural, one {# دقیقه} other {# دقیقه}}",
  "keyboard_shortcuts.back": "بازگشت",
  "keyboard_shortcuts.blocked": "گشودن سیاههٔ کاربران مسدود",
  "keyboard_shortcuts.boost": "تقویت فرسته",
  "keyboard_shortcuts.column": "برای تمرکز روی یک فرسته در یکی از ستون‌ها",
  "keyboard_shortcuts.compose": "تمرکز روی محیط نوشتن",
  "keyboard_shortcuts.description": "توضیح",
  "keyboard_shortcuts.direct": "گشودن ستون اشاره‌های خصوصی",
  "keyboard_shortcuts.down": "پایین بردن در سیاهه",
  "keyboard_shortcuts.enter": "گشودن فرسته",
  "keyboard_shortcuts.explore": "گشودن خط زمانی داغ",
  "keyboard_shortcuts.favourite": "پسندیدن فرسته",
  "keyboard_shortcuts.favourites": "گشودن فهرست برگزیده‌ها",
  "keyboard_shortcuts.federated": "گشودن خط زمانی همگانی",
  "keyboard_shortcuts.heading": "میان‌برهای صفحه‌کلید",
  "keyboard_shortcuts.home": "گشودن خط زمانی خانگی",
  "keyboard_shortcuts.hotkey": "میان‌بر",
  "keyboard_shortcuts.legend": "نمایش این نشانه",
  "keyboard_shortcuts.load_more": "تمرکز روی دکمهٔ «بار کردن بیش‌تر»",
  "keyboard_shortcuts.local": "گشودن خط زمانی محلی",
  "keyboard_shortcuts.mention": "اشاره به نویسنده",
  "keyboard_shortcuts.muted": "گشودن فهرست کاربران خموش",
  "keyboard_shortcuts.my_profile": "گشودن نمایه‌تان",
  "keyboard_shortcuts.notifications": "گشودن ستون آگاهی‌ها",
  "keyboard_shortcuts.open_media": "گشودن رسانه",
  "keyboard_shortcuts.pinned": "گشودن سیاههٔ فرسته‌های سنجاق شده",
  "keyboard_shortcuts.profile": "گشودن نمایهٔ نویسنده",
  "keyboard_shortcuts.quote": "نقل فرسته",
  "keyboard_shortcuts.reply": "پاسخ به فرسته",
  "keyboard_shortcuts.requests": "گشودن سیاههٔ درخواست‌های پی‌گیری",
  "keyboard_shortcuts.search": "تمرکز روی نوار جست‌وجو",
  "keyboard_shortcuts.spoilers": "نمایش/نهفتن زمینهٔ هشدار محتوا",
  "keyboard_shortcuts.start": "گشودن ستون «آغاز کنید»",
  "keyboard_shortcuts.toggle_hidden": "نمایش/نهفتن نوشتهٔ پشت هشدار محتوا",
  "keyboard_shortcuts.toggle_sensitivity": "نمایش/نهفتن رسانه",
  "keyboard_shortcuts.toot": "شروع یک فرستهٔ جدید",
  "keyboard_shortcuts.top": "جابه‌جایی به بالای سیاهه",
  "keyboard_shortcuts.translate": "برای ترجمه یک پست",
  "keyboard_shortcuts.unfocus": "برداشتن تمرکز از ناحیهٔ نوشتن یا جست‌وجو",
  "keyboard_shortcuts.up": "بالا بردن در سیاهه",
  "learn_more_link.got_it": "متوجه شدم",
  "learn_more_link.learn_more": "دانستن بیش‌تر",
  "lightbox.close": "بستن",
  "lightbox.next": "بعدی",
  "lightbox.previous": "قبلی",
  "lightbox.zoom_in": "بزرگ‌نمایی به اندازهٔ اصلی",
  "lightbox.zoom_out": "بزرگ نمایی برای برازش",
  "limited_account_hint.action": "به هر روی نمایه نشان داده شود",
  "limited_account_hint.title": "این نمایه از سوی ناظم‌های {domain} پنهان شده.",
  "link_preview.author": "از {name}",
  "link_preview.more_from_author": "بیش‌تر از {name}",
  "link_preview.shares": "{count, plural, one {{counter} فرسته} other {{counter} فرسته}}",
  "lists.add_member": "افزودن",
  "lists.add_to_list": "افزودن به سیاهه",
  "lists.add_to_lists": "افزودن {name} به سیاهه‌ها",
  "lists.create": "ایجاد",
  "lists.create_a_list_to_organize": "ایحاد فهرستی جدید برای سازمان‌دهی خوراک خانگیتان",
  "lists.create_list": "ایجاد سیاهه",
  "lists.delete": "حذف سیاهه",
  "lists.done": "انجام شد",
  "lists.edit": "ویرایش سیاهه",
  "lists.exclusive": "نهفتن اعضا در خانه",
  "lists.exclusive_hint": "اگر کسی در این سیاهه باشد، در خوراک خانگیتان نهفته تا از نمایش دویارهٔ فرسته‌هایش خودداری شود.",
  "lists.find_users_to_add": "یافتن کاربرانی برای افزودن",
  "lists.list_members_count": "{count, plural,one {# عضو}other {# عضو}}",
  "lists.list_name": "نام سیاهه",
  "lists.new_list_name": "نام سیاههٔ جدید",
  "lists.no_lists_yet": "هنوز هیچ سیاهه‌ای نیست.",
  "lists.no_members_yet": "هنوز هیچ عضوی نیست.",
  "lists.no_results_found": "هیچ نتیجه‌ای پیدا نشد.",
  "lists.remove_member": "حذف",
  "lists.replies_policy.followed": "هر کاربر پی‌گرفته",
  "lists.replies_policy.list": "اعضای سیاهه",
  "lists.replies_policy.none": "هیچ کدام",
  "lists.save": "ذخیره",
  "lists.search": "جست‌وجو",
  "lists.show_replies_to": "شامل پاسخ از اعضای لیست به",
  "load_pending": "{count, plural, one {# مورد جدید} other {# مورد جدید}}",
  "loading_indicator.label": "بار کردن…",
  "media_gallery.hide": "نهفتن",
  "moved_to_account_banner.text": "حسابتان {disabledAccount} اکنون از کار افتاده؛ چرا که به {movedToAccount} منتقل شدید.",
  "mute_modal.hide_from_notifications": "نهفتن از آگاهی‌ها",
  "mute_modal.hide_options": "گزینه‌های نهفتن",
  "mute_modal.indefinite": "تا وقتی ناخموشش کنم",
  "mute_modal.show_options": "نمایش گزینه‌ها",
  "mute_modal.they_can_mention_and_follow": "می‌تواند به شما اشاره کرده و پیتان بگیرد؛ ولی نخواهید دیدش.",
  "mute_modal.they_wont_know": "نخواهد دانست که خموش شده.",
  "mute_modal.title": "خموشی کاربر؟",
  "mute_modal.you_wont_see_mentions": "فرسته‌هایی که به او اشاره کرده‌اند را نخواهید دید.",
  "mute_modal.you_wont_see_posts": "همچنان می‌تواند فرسته‌هایتان را ببینند؛ ولی فرسته‌هایش را نمی‌بینید.",
  "navigation_bar.about": "درباره",
  "navigation_bar.account_settings": "گذرواژه و امنیت",
  "navigation_bar.administration": "مدیریت",
  "navigation_bar.advanced_interface": "بازکردن در رابط کاربری وب پیشرفته",
  "navigation_bar.automated_deletion": "حذف خودکار فرسته",
  "navigation_bar.blocks": "کاربران مسدود شده",
  "navigation_bar.bookmarks": "نشانک‌ها",
  "navigation_bar.collections": "مجموعه‌ها",
  "navigation_bar.direct": "اشاره‌های خصوصی",
  "navigation_bar.domain_blocks": "دامنه‌های مسدود شده",
  "navigation_bar.favourites": "برگزیده‌ها",
  "navigation_bar.filters": "واژه‌های خموش",
  "navigation_bar.follow_requests": "درخواست‌های پی‌گیری",
  "navigation_bar.followed_tags": "برچسب‌های پی‌گرفته",
  "navigation_bar.follows_and_followers": "پی‌گرفتگان و پی‌گیرندگان",
  "navigation_bar.import_export": "درون‌ریزی و برون‌بری",
  "navigation_bar.lists": "سیاهه‌ها",
  "navigation_bar.live_feed_local": "خوراک زنده (محلی)",
  "navigation_bar.live_feed_public": "خوراک زنده (عمومی)",
  "navigation_bar.logout": "خروج",
  "navigation_bar.moderation": "نظارت",
  "navigation_bar.more": "بیشتر",
  "navigation_bar.mutes": "کاربران خموشانده",
  "navigation_bar.opened_in_classic_interface": "فرسته‌ها، حساب‌ها و دیگر صفحه‌های خاص به طور پیش‌گزیده در میانای وب کلاسیک گشوده می‌شوند.",
  "navigation_bar.preferences": "ترجیحات",
  "navigation_bar.privacy_and_reach": "محرمانگی و دسترسی",
  "navigation_bar.search": "جست‌وجو",
  "navigation_bar.search_trends": "جستجو \\ پرطرفدار",
  "navigation_panel.collapse_followed_tags": "جمع کردن فهرست برچسب‌های پی‌گرفته",
  "navigation_panel.collapse_lists": "جمع کردن فهرست سیاهه",
  "navigation_panel.expand_followed_tags": "گسترش فهرست برچسب‌های پی‌گرفته",
  "navigation_panel.expand_lists": "گسترش فهرست سیاهه",
  "not_signed_in_indicator.not_signed_in": "برای دسترسی به این منبع باید وارد شوید.",
  "notification.added_to_collection": "‫{name} به مجموعه‌ای افزودتان",
  "notification.admin.report": "{name}، {target} را گزارش داد",
  "notification.admin.report_account": "{name} {count, plural, one {یک پست} other {پست}} از {target} برای {category} را گزارش داد",
  "notification.admin.report_account_other": "{name} {count, plural, one {یک پست} other {پست}} از {target} را گزارش داد",
  "notification.admin.report_statuses": "{name} {target} برای {category} را گزارش داد",
  "notification.admin.report_statuses_other": "{name}، {target} را گزارش داد",
  "notification.admin.sign_up": "{name} ثبت نام کرد",
  "notification.admin.sign_up.name_and_others": "{name} و {count, plural, one {# نفر دیگر} other {# نفر دیگر}} ثبت‌نام کردند",
  "notification.annual_report.message": "#خلاصه_ماستودون {year} منتظرتان است! رونمایی از لحظه‌های به یاد ماندنی و نقاط پررنگ سال روی ماستودون!",
  "notification.annual_report.view": "دیدن #خلاصه_ماستودون",
  "notification.collection_update": "‫{name} مجموعه‌ای که در آن هستید را ویراست",
  "notification.favourite": "{name} فرسته‌تان را برگزید",
  "notification.favourite.name_and_others_with_link": "{name} و <a>{count, plural, one {# نفر دیگر} other {# نفر دیگر}}</a> فرسته‌تان را برگزیدند",
  "notification.favourite_pm": "{name} اشارهٔ خصوصیتان را برگزید",
  "notification.favourite_pm.name_and_others_with_link": "‏{name} و <a>{count, plural, one {# نفر دیگر} other {# نفر دیگر}}</a> اشارهٔ خصوصیتان را برگزیدند",
  "notification.follow": "‫{name}‬ پی‌گیرتان شد",
  "notification.follow.name_and_others": "{name} و <a>{count, plural, other {#}} نفر دیگر</a> پیتان گرفتند",
  "notification.follow_request": "{name} درخواست پی‌گیریتان را داد",
  "notification.follow_request.name_and_others": "{name} و {count, plural, one {# نفر دیگر} other {# نفر دیگر}} درخواست پی‌گیریتان را دادند",
  "notification.label.mention": "اشاره",
  "notification.label.private_mention": "اشارهٔ خصوصی",
  "notification.label.private_reply": "پاسخ خصوصی",
  "notification.label.quote": "{name} فرسته‌تان را نقل کرد",
  "notification.label.reply": "پاسخ",
  "notification.mention": "اشاره",
  "notification.mentioned_you": "‫{name}‬ از شما نام برد",
  "notification.moderation-warning.learn_more": "بیشتر بدانید",
  "notification.moderation_warning": "هشداری مدیریتی گرفته‌اید",
  "notification.moderation_warning.action_delete_statuses": "برخی از فرسته‌هایتان برداشته شدند.",
  "notification.moderation_warning.action_disable": "حسابتان از کار افتاد.",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "برخی از فرسته‌هایتان به عنوان حسّاس علامت خوردند.",
  "notification.moderation_warning.action_none": "حسابتان هشداری مدیریتی گرفت.",
  "notification.moderation_warning.action_sensitive": "فرسته‌هایتان از اکنون به عنوان حسّاس علامت خواهند خورد.",
  "notification.moderation_warning.action_silence": "حسابتان محدود شده.",
  "notification.moderation_warning.action_suspend": "حسابتان معلّق شده.",
  "notification.own_poll": "نظرسنجیتان پایان یافت",
  "notification.poll": "نظرسنجی‌ای که در آن رأی دادید به پایان رسید",
  "notification.quoted_update": "‏{name} فرسته‌ای که نقل کردید را ویراست",
  "notification.reblog": "‫{name}‬ فرسته‌تان را تقویت کرد",
  "notification.reblog.name_and_others_with_link": "{name} و <a>{count, plural, one {# نفر دیگر} other {# نفر دیگر}}</a> فرسته‌تان را تقویت کردند",
  "notification.relationships_severance_event": "قطع ارتباط با {name}",
  "notification.relationships_severance_event.account_suspension": "یک سرپرست از {from} {target} را به حالت تعلیق درآورده است، به این معنی که دیگر نمی‌توانید به‌روزرسانی‌ها را از آنها دریافت کنید یا با آنها تعامل داشته باشید.",
  "notification.relationships_severance_event.domain_block": "یک سرپرست از {from} {target} را مسدود کرده است، از جمله {followersCount} از دنبال‌کنندگان شما و {followingCount, plural, one {حساب} other {حساب‌}} که دنبال می‌کنید.",
  "notification.relationships_severance_event.learn_more": "بیشتر بدانید",
  "notification.relationships_severance_event.user_domain_block": "شما {target} را مسدود کرده‌اید، {followersCount} از دنبال‌کنندگان خود و {followingCount, plural, one {حساب} other {حساب}} که دنبال می‌کنید را حذف کرده‌اید.",
  "notification.status": "{name} چیزی فرستاد",
  "notification.update": "{name} فرسته‌ای را ویرایش کرد",
  "notification_requests.accept": "پذیرش",
  "notification_requests.accept_multiple": "{count, plural, one {پذیرش درخواست…} other {پذیرش درخواست‌ها…}}",
  "notification_requests.confirm_accept_multiple.button": "پذیرش {count, plural,one {درخواست} other {درخواست‌ها}}",
  "notification_requests.confirm_accept_multiple.message": "دارید {count, plural,one {یک}other {#}} درخواست آگاهی را می‌پذیرید. مطمئنید که می‌خواهید ادامه دهید؟",
  "notification_requests.confirm_accept_multiple.title": "پذیرش درخواست‌های آگاهی؟",
  "notification_requests.confirm_dismiss_multiple.button": "رد {count, plural,one {درخواست} other {درخواست‌ها}}",
  "notification_requests.confirm_dismiss_multiple.message": "دارید {count, plural, one {یک درخواست آگاهی} other {# درخواست آگاهی}} را رد می‌کنید که دیگر نمی توانید به راحتی به {count, plural, one {آن} other {آن‌ها}} دسترسی پیدا کنید. مطمئنید که می‌خواهید ادامه دهید؟",
  "notification_requests.confirm_dismiss_multiple.title": "رد کردن درخواست‌های آگاهی؟",
  "notification_requests.dismiss": "دورانداختن",
  "notification_requests.dismiss_multiple": "{count, plural, one {دورانداختن درخواست…} other {دورانداختن درخواست‌ها…}}",
  "notification_requests.edit_selection": "ویرایش",
  "notification_requests.exit_selection": "انجام شد",
  "notification_requests.explainer_for_limited_account": "اعلان‌های این حساب فیلتر شده‌اند زیرا حساب توسط یک ناظر محدود شده است.",
  "notification_requests.explainer_for_limited_remote_account": "اعلان‌های این حساب فیلتر شده‌اند زیرا حساب یا سرور آن توسط ناظر محدود شده است.",
  "notification_requests.maximize": "بیشنه",
  "notification_requests.minimize_banner": "کمینه کردن بیرق آگاهی‌های پالوده",
  "notification_requests.notifications_from": "آگاهی‌ها از {name}",
  "notification_requests.title": "آگاهی‌های پالوده",
  "notification_requests.view": "دیدن آگاهی‌ها",
  "notifications.clear": "پاک‌سازی آگاهی‌ها",
  "notifications.clear_confirmation": "مطمئنید می‌خواهید همهٔ آگاهی‌هایتان را برای همیشه پاک کنید؟",
  "notifications.clear_title": "پاک‌سازی آگاهی‌ها؟",
  "notifications.column_settings.admin.report": "گزارش‌های جدید:",
  "notifications.column_settings.admin.sign_up": "ثبت نام‌های جدید:",
  "notifications.column_settings.alert": "آگاهی‌های میزکار",
  "notifications.column_settings.favourite": "برگزیده‌ها:",
  "notifications.column_settings.filter_bar.advanced": "نمایش همۀ دسته‌ها",
  "notifications.column_settings.filter_bar.category": "نوار پالایش سریع",
  "notifications.column_settings.follow": "پی‌گیرندگان جدید:",
  "notifications.column_settings.follow_request": "درخواست‌های جدید پی‌گیری:",
  "notifications.column_settings.group": "گروه",
  "notifications.column_settings.mention": "اشاره‌ها:",
  "notifications.column_settings.poll": "نتایج نظرسنجی:",
  "notifications.column_settings.push": "آگاهی‌های ارسالی",
  "notifications.column_settings.quote": "نقل‌قول‌ها:",
  "notifications.column_settings.reblog": "تقویت‌ها:",
  "notifications.column_settings.show": "نمایش در ستون",
  "notifications.column_settings.sound": "پخش صدا",
  "notifications.column_settings.status": "فرسته‌های جدید:",
  "notifications.column_settings.unread_notifications.category": "آگاهی‌های خوانده نشده",
  "notifications.column_settings.unread_notifications.highlight": "پررنگ کردن آگاهی‌های خوانده نشده",
  "notifications.column_settings.update": "ویرایش‌ها:",
  "notifications.filter.all": "همه",
  "notifications.filter.boosts": "تقویت‌ها",
  "notifications.filter.favourites": "برگزیده‌ها",
  "notifications.filter.follows": "پی‌گرفتن‌ها",
  "notifications.filter.mentions": "اشاره‌ها",
  "notifications.filter.polls": "نتایج نظرسنجی",
  "notifications.filter.statuses": "به‌روز رسانی‌ها از کسانی که پی‌گیرشانید",
  "notifications.grant_permission": "اعطای مجوز.",
  "notifications.group": "{count} آگاهی",
  "notifications.mark_as_read": "نشانه‌گذاری تمام آگاهی‌ها به خوانده‌شده",
  "notifications.permission_denied": "آگاهی‌های میزکار به دلیل رد کردن درخواست اجازهٔ پیشین مرورگر، در دسترس نیستند",
  "notifications.permission_denied_alert": "از آن‌جا که پیش از این اجازهٔ مرورگر رد شده است، آگاهی‌های میزکار نمی‌توانند به کار بیفتند",
  "notifications.permission_required": "آگاهی‌های میزکار در دسترس نیستند زیرا اجازه‌های لازم، اعطا نشده.",
  "notifications.policy.accept": "پذیرش",
  "notifications.policy.accept_hint": "نمایش در آگاهی‌ها",
  "notifications.policy.drop": "چشم‌پوشی",
  "notifications.policy.drop_hint": "فرستادن به هیچ. دیگر هرگز دیده نخواهند شد",
  "notifications.policy.filter": "پالایش",
  "notifications.policy.filter_hint": "فرستادن به صندوق آگاهی‌های پالوده",
  "notifications.policy.filter_limited_accounts_hint": "محدود شده به دست ناظم‌های کارساز",
  "notifications.policy.filter_limited_accounts_title": "حساب‌های مدیریت شده",
  "notifications.policy.filter_new_accounts.hint": "ساخته شده در {days, plural, one {یک} other {#}} روز اخیر",
  "notifications.policy.filter_new_accounts_title": "حساب‌های جدید",
  "notifications.policy.filter_not_followers_hint": "از جمله کسانی که کم‌تر از {days, plural, one {یک} other {#}} روز است پیتان می‌گیرند",
  "notifications.policy.filter_not_followers_title": "کسانی که شما را دنبال میکنند",
  "notifications.policy.filter_not_following_hint": "تا به صورت دستی تأییدشان کنید",
  "notifications.policy.filter_not_following_title": "کسانی که پی نمی‌گیرید",
  "notifications.policy.filter_private_mentions_hint": "پالوده مگر این که به نام‌بری خودتان پاسخ داده یا پی‌گیر فرستنده باشید",
  "notifications.policy.filter_private_mentions_title": "نام‌بری‌های خصوصی ناخواسته",
  "notifications.policy.title": "مدیریت آگاهی‌ها از…",
  "notifications_permission_banner.enable": "به کار انداختن آگاهی‌های میزکار",
  "notifications_permission_banner.how_to_control": "برای دریافت آگاهی‌ها هنگام باز نبودن ماستودون، آگاهی‌های میزکار را به کار بیندازید. پس از به کار افتادنشان می‌توانید گونه‌های دقیق برهم‌کنش‌هایی که آگاهی‌های میزکار تولید می‌کنند را از {icon} بالا واپایید.",
  "notifications_permission_banner.title": "هرگز چیزی را از دست ندهید",
  "onboarding.follows.back": "بازگشت",
  "onboarding.follows.empty": "متأسفانه هم‌اکنون نتیجه‌ای قابل نمایش نیست. می‌توانید استفاده از جست‌وجو یا مرور صفحهٔ کاوش را برای یافتن افرادی برای پی‌گیری آزموده یا دوباره تلاش کنید.",
  "onboarding.follows.next": "بعدی: برپا کردن نماگرتان",
  "onboarding.follows.search": "جست‌وجو",
  "onboarding.follows.title": "پی گرفتن افرادی برای آغاز",
  "onboarding.profile.discoverable": "نمایه خود را قابل نمایش کنید",
  "onboarding.profile.discoverable_hint": "خواسته‌اید روی ماستودون کشف شوید. ممکن است فرسته‌هایتان در نتیحهٔ جست‌وجوها و فرسته‌های داغ ظاهر شده و نمایه‌تان به افرادی با علایق مشابهتان پیشنهاد شود.",
  "onboarding.profile.display_name": "نام نمایشی",
  "onboarding.profile.display_name_hint": "نام کامل یا نام باحالتان…",
  "onboarding.profile.finish": "پايان",
  "onboarding.profile.note": "درباره شما",
  "onboarding.profile.note_hint": "می‌توانید افراد دیگر را @نام‌بردن یا #برچسب بزنید…",
  "onboarding.profile.title": "تنظیم نمایه",
  "onboarding.profile.upload_avatar": "بازگذاری تصویر نمایه",
  "onboarding.profile.upload_header": "بارگذاری تصویر سردر نمایه",
  "password_confirmation.exceeds_maxlength": "تأییدیه گذرواژه از حداکثر طول گذرواژه بیشتر است",
  "password_confirmation.mismatching": "تایید گذرواژه با گذرواژه مطابقت ندارد",
  "picture_in_picture.restore": "برگرداندن",
  "poll.closed": "پایان‌یافته",
  "poll.refresh": "نوسازی",
  "poll.reveal": "دیدن نتایج",
  "poll.total_people": "{count, plural, one {# نفر} other {# نفر}}",
  "poll.total_votes": "{count, plural, one {# رأی} other {# رأی}}",
  "poll.vote": "رأی",
  "poll.voted": "شما به این جواب رأی دادید",
  "poll.votes": "{votes, plural, one {# رأی} other {# رأی}}",
  "poll_button.add_poll": "افزودن نظرسنجی",
  "poll_button.remove_poll": "برداشتن نظرسنجی",
  "privacy.change": "تغییر محرمانگی فرسته",
  "privacy.direct.long": "هرکسی که در فرسته نام برده شده",
  "privacy.direct.short": "اشارهٔ خصوصی",
  "privacy.private.long": "تنها پی‌گیرندگانتان",
  "privacy.private.short": "پی‌گیرندگان",
  "privacy.public.long": "هرکسی در و بیرون از ماستودون",
  "privacy.public.short": "عمومی",
  "privacy.quote.anyone": "‏{visibility}، نقل مجاز",
  "privacy.quote.disabled": "‏{visibility}، نقل‌ها از کار افتاده",
  "privacy.quote.limited": "‏{visibility}، نقل‌ها محدود شده",
  "privacy.unlisted.additional": "درست مثل عمومی رفتار می‌کند؛ جز این که فرسته در برچسب‌ها یا خوراک‌های زنده، کشف یا جست‌وجوی ماستودون ظاهر نخواهد شد. حتا اگر کلیّت نمایه‌تان اجازه داده باشد.",
  "privacy.unlisted.long": "نهفته از نتیجه‌های جست‌وجوی ماستودون و خط‌های زمانی داغ و عمومی",
  "privacy.unlisted.short": "عمومی ساکت",
  "privacy_policy.last_updated": "آخرین به‌روز رسانی در {date}",
  "privacy_policy.title": "سیاست محرمانگی",
  "quote_error.edit": "هنگام ویراستن فرسته نمی‌توان نقلی افزود.",
  "quote_error.poll": "نقل نظرسنجی‌ها مجاز نیست.",
  "quote_error.private_mentions": "نقل اشاره‌های مستقیم مجاز نیست.",
  "quote_error.quote": "در هر زمان تنها یک نقل مجاز است.",
  "quote_error.unauthorized": "مجاز به نقل این فرسته نیستید.",
  "quote_error.upload": "نقل پیوست‌های رسانه‌ای مجاز نیست.",
  "recommended": "پیشنهادشده",
  "refresh": "نوسازی",
  "regeneration_indicator.please_stand_by": "لطفا منتظر باشید.",
  "regeneration_indicator.preparing_your_home_feed": "آماده کردن خوراک خانگیتان…",
  "relative_time.days": "{number} روز",
  "relative_time.full.days": "{number, plural, one {# روز} other {# روز}} پیش",
  "relative_time.full.hours": "{number, plural, one {# ساعت} other {# ساعت}} پیش",
  "relative_time.full.just_now": "همين آلان",
  "relative_time.full.minutes": "{number, plural, one {# دقیقه} other {# دقیقه}} پیش",
  "relative_time.full.seconds": "{number, plural, one {# ثانیه} other {# ثانیه}} پیش",
  "relative_time.hours": "{number} ساعت",
  "relative_time.just_now": "حالا",
  "relative_time.minutes": "{number} دقیقه",
  "relative_time.seconds": "{number} ثانیه",
  "relative_time.today": "امروز",
  "remove_quote_hint.button_label": "گرفتم",
  "remove_quote_hint.message": "می‌توانید این کار را از {icon} فهرست گزینه‌ها انجام دهید.",
  "remove_quote_hint.title": "می‌خواهید فرستهٔ نقل شده‌تان را بردارید؟",
  "reply_indicator.attachments": "{count, plural, one {# پیوست} other {# پیوست}}",
  "reply_indicator.cancel": "لغو",
  "reply_indicator.poll": "نظرسنجی",
  "report.block": "انسداد",
  "report.block_explanation": "فرسته‌هایش را نخواهید دید. نخواهد توانست فرسته‌هایتان را دیده یا پیتان بگیرد. قادر است تشخیص دهد مسدود شده.",
  "report.categories.legal": "حقوقی",
  "report.categories.other": "غیره",
  "report.categories.spam": "هرزنامه",
  "report.categories.violation": "محتوا یک یا چند قانون کارساز را نقض می‌کند",
  "report.category.subtitle": "منطبق‌ترین را انتخاب کنید",
  "report.category.title": "به ما بگویید با این {type} چه مشکلی دارید",
  "report.category.title_account": "نمایه",
  "report.category.title_status": "فرسته",
  "report.close": "انجام شد",
  "report.collection_comment": "چرا می‌خواهید این مجموعه را گزارش دهید؟",
  "report.comment.title": "آیا چیز دیگری هست که فکر می‌کنید باید بدانیم؟",
  "report.forward": "فرستادن به {target}",
  "report.forward_hint": "این حساب در کارساز دیگری ثبت شده. آیا می‌خواهید رونوشتی ناشناس از این گزارش به آن‌جا هم فرستاده شود؟",
  "report.mute": "خموش",
  "report.mute_explanation": "فرسته‌هایش را نخواهید دید. همچنان خواهد توانست پیتان گرفته و فرسته‌هایتان را ببیند. نخواهد دانست که خموش شده.",
  "report.next": "بعدی",
  "report.placeholder": "توضیحات اضافه",
  "report.reasons.dislike": "من آن را دوست ندارم",
  "report.reasons.dislike_description": "این چیزی نیست که بخواهید ببینید",
  "report.reasons.legal": "غیرقانونیست",
  "report.reasons.legal_description": "معتقدید قوانین کشور شما یا کارساز را زیر پا می‌گذارد",
  "report.reasons.other": "به خاطر چیز دیگری است",
  "report.reasons.other_description": "این موضوع در دسته‌بندی‌های دیگر نمی‌گنجد",
  "report.reasons.spam": "این هرزنامه است",
  "report.reasons.spam_description": "پیوندهای مخرب، تعامل جعلی یا پاسخ‌های تکراری",
  "report.reasons.violation": "قوانین کارساز را نقض می‌کند",
  "report.reasons.violation_description": "شما آگاه هستید که قوانین خاصی را زیر پا می‌گذارد",
  "report.rules.subtitle": "همهٔ موارد انجام شده را برگزینید",
  "report.rules.title": "کدام قوانین نقض شده‌اند؟",
  "report.statuses.subtitle": "همهٔ موارد انجام شده را برگزینید",
  "report.statuses.title": "آیا فرسته‌ای وجود دارد که از این گزارش پشتیبانی کند؟",
  "report.submission_error": "گزارش نتوانست ثبت شود",
  "report.submission_error_details": "لزفاً اتّصال شبکه‌تان را بررسی کرده و دوباره تلاش کنید.",
  "report.submit": "فرستادن",
  "report.target": "گزارش کردن {target}",
  "report.thanks.take_action": "در اینجا گزینه‌هایی برای کنترل آنچه در ماستودون میبینید، وجود دارد:",
  "report.thanks.take_action_actionable": "تا بررسیش می‌کنیم می‌توانید علیه ‎@{name} اقدام کنید:",
  "report.thanks.title": "نمی‌خواهید این را ببینید؟",
  "report.thanks.title_actionable": "ممنون بابت گزارش، ما آن را بررسی خواهیم کرد.",
  "report.unfollow": "پی‌نگرفتن ‎@{name}",
  "report.unfollow_explanation": "شما این حساب را پی‌گرفته‌اید، برای اینکه دیگر فرسته‌هایش را در خوراک خانه‌تان نبینید؛ آن را پی‌نگیرید.",
  "report_notification.attached_statuses": "{count, plural, one {{count} فرسته} other {{count} فرسته}} پیوست شده",
  "report_notification.categories.legal": "قانونی",
  "report_notification.categories.legal_sentence": "محتوای غیرقانونی",
  "report_notification.categories.other": "دیگر",
  "report_notification.categories.other_sentence": "دیگر",
  "report_notification.categories.spam": "هرزنامه",
  "report_notification.categories.spam_sentence": "هرزنامه",
  "report_notification.categories.violation": "تخطّی از قانون",
  "report_notification.categories.violation_sentence": "تخطّی از قانون",
  "report_notification.open": "گشودن گزارش",
  "search.clear": "پاک‌سازی جست‌وجو",
  "search.no_recent_searches": "جست‌وجوی اخیری نیست",
  "search.placeholder": "جست‌وجو",
  "search.quick_action.account_search": "نمایه‌های جور با {x}",
  "search.quick_action.go_to_account": "برو به نمایه {x}",
  "search.quick_action.go_to_hashtag": "برو به برچسب {x}",
  "search.quick_action.open_url": "باز کردن پیوند در ماستودون",
  "search.quick_action.status_search": "فرسته‌های جور با {x}",
  "search.search_or_paste": "جست‌وجو یا جایگذاری نشانی",
  "search_popout.full_text_search_disabled_message": "روی {domain} موجود نیست.",
  "search_popout.full_text_search_logged_out_message": "تنها زمانی که وارد شده‌اید دردسترس است.",
  "search_popout.language_code": "کد زبان ایزو",
  "search_popout.options": "گزینه‌های جست‌وجو",
  "search_popout.quick_actions": "کنش‌های سریع",
  "search_popout.recent": "جست‌وجوهای اخیر",
  "search_popout.specific_date": "تاریخ مشخص",
  "search_popout.user": "کاربر",
  "search_results.accounts": "نمایه‌ها",
  "search_results.all": "همه",
  "search_results.hashtags": "برچسب‌ها",
  "search_results.no_results": "هیچ نتیجه ای وجود ندارد.",
  "search_results.no_search_yet": "سعی کنید پست ها، نمایه ها یا هشتگ ها را جستجو کنید.",
  "search_results.see_all": "دیدن همه",
  "search_results.statuses": "فرسته‌ها",
  "search_results.title": "جستجو برای \"{q}\"",
  "server_banner.about_active_users": "افرادی که در ۳۰ روز گذشته از این کارساز استفاده کرده‌اند (کاربران فعّال ماهانه)",
  "server_banner.active_users": "کاربر فعّال",
  "server_banner.administered_by": "به مدیریت:",
  "server_banner.is_one_of_many": "{domain} یکی از بسیاری از سرورهای مستقل ماستودون است که می توانید از آن برای شرکت در fediverse استفاده کنید.",
  "server_banner.more_about_this_server": "بیش‌تر دربارهٔ این کارساز",
  "server_banner.server_stats": "آمار کارساز:",
  "sign_in_banner.create_account": "ایجاد حساب",
  "sign_in_banner.follow_anyone": "هر کسی را در سراسر فدیورس دنبال کنید و همه را به ترتیب زمانی ببینید. هیچ الگوریتم، تبلیغات یا طعمه کلیکی در چشم نیست.",
  "sign_in_banner.mastodon_is": "ماستودون بهترین راه برای پیگیری اتفاقات است.",
  "sign_in_banner.sign_in": "ورود",
  "sign_in_banner.sso_redirect": "ورود یا ثبت نام",
  "skip_links.skip_to_content": "پرش به محتوای اصلی",
  "skip_links.skip_to_navigation": "پرش به پیمایش اصلی",
  "status.admin_account": "گشودن واسط مدیریت برای ‎@{name}",
  "status.admin_domain": "گشودن واسط مدیریت برای ‎{domain}",
  "status.admin_status": "گشودن این فرسته در واسط مدیریت",
  "status.all_disabled": "تقویت‌ها و نقل‌ها از کار افتاده‌اند",
  "status.block": "انسداد ‎@{name}",
  "status.bookmark": "نشانک",
  "status.cancel_reblog_private": "ناتقویت",
  "status.cannot_quote": "مجاز به نقل این فرسته نیستید",
  "status.cannot_reblog": "این فرسته قابل تقویت نیست",
  "status.contains_quote": "دارای نقل",
  "status.context.loading": "بار کردن پاسخ‌های بیش‌تر",
  "status.context.loading_error": "نتوانست پاسخ‌های بیش‌تری بار کند",
  "status.context.loading_success": "پاسخ‌های جدید بار شدند",
  "status.context.more_replies_found": "پاسخ‌های بیش‌تری پیدا شد",
  "status.context.retry": "تلاش دوباره",
  "status.context.show": "نمایش",
  "status.continued_thread": "رشتهٔ دنباله دار",
  "status.copy": "رونوشت از پیوند فرسته",
  "status.delete": "حذف",
  "status.delete.success": "فرسته حذف شد",
  "status.detailed_status": "نمایش کامل گفتگو",
  "status.direct": "اشارهٔ خصوصی به ‪@{name}‬",
  "status.direct_indicator": "اشارهٔ خصوصی",
  "status.edit": "ویرایش",
  "status.edited": "آخرین ویرایش {date}",
  "status.edited_x_times": "{count, plural, one {{count} مرتبه} other {{count} مرتبه}} ویرایش شد",
  "status.embed": "گرفتن کد تعبیه",
  "status.favourite": "برگزیده‌",
  "status.favourites_count": "{count, plural, one {{counter} برگزیدن} other {{counter} برگزیدن}}",
  "status.filter": "پالایش این فرسته",
  "status.history.created": "توسط {name} در {date} ایجاد شد",
  "status.history.edited": "توسط {name} در {date} ویرایش شد",
  "status.load_more": "بار کردن بیش‌تر",
  "status.media.open": "کلیک برای گشودن",
  "status.media.show": "کلیک برای نمایش",
  "status.media_hidden": "رسانهٔ نهفته",
  "status.mention": "اشاره به ‎@{name}",
  "status.more": "بیشتر",
  "status.mute": "خموشاندن ‎@{name}",
  "status.mute_conversation": "خموشاندن گفت‌وگو",
  "status.open": "گسترش این فرسته",
  "status.pin": "سنجاق به نمایه",
  "status.quote": "نقل‌قول",
  "status.quote.cancel": "لغو نقل",
  "status.quote_error.blocked_account_hint.title": "این فرسته نهفته است چرا که ‪@{name}‬ را مسدود کرده‌اید.",
  "status.quote_error.blocked_domain_hint.title": "این فرسته نهفته است چرا که {domain} را مسدود کرده‌اید.",
  "status.quote_error.filtered": "نهفته بنا بر یکی از پالایه‌هایتان",
  "status.quote_error.limited_account_hint.action": "نمایش به هر روی",
  "status.quote_error.limited_account_hint.title": "این حساب به دست ناظم‌های {domain} پنهان شده.",
  "status.quote_error.muted_account_hint.title": "این فرسته نهفته است چرا که ‪@{name}‬ را خموش کرده‌اید.",
  "status.quote_error.not_available": "فرسته در دسترس نیست",
  "status.quote_error.pending_approval": "فرسته منتظر",
  "status.quote_error.pending_approval_popout.body": "روی ماستودون می‌توان افراد مجاز به نقل را واپایید. این فرسته تا زمان گرفتن تأییده از نگارندهٔ اصلی معلّق است.",
  "status.quote_error.revoked": "فرسته به دست نگارنده برداشته شد",
  "status.quote_followers_only": "تنها پی‌گیران می‌توانند این فرسته را نقل کنند",
  "status.quote_manual_review": "نگارنده به صورت دستی بررسی خواهد کرد",
  "status.quote_noun": "نقل",
  "status.quote_policy_change": "تغییر کسانی که می‌توانند نقل کنند",
  "status.quote_post_author": "فرسته‌ای از @{name} نقل شد",
  "status.quote_private": "فرسته‌های خصوصی نمی‌توانند نقل شوند",
  "status.quotes.empty": "هنوز کسی این فرسته را نقل نکرده. وقتی کسی چنین کند این‌جا نشان داده خواهد شد.",
  "status.quotes.local_other_disclaimer": "نقل‌هایی که به دست نگارنده رد شده باشند نشان داده نخواهند شد.",
  "status.quotes.remote_other_disclaimer": "تنها نقل‌ها از {domain} تضمین نمایش در این‌جا را دارند. نقل‌های رد شده به دست نگاره نشان داده نخواهند شد.",
  "status.quotes_count": "{count, plural, one {{counter} نقل} other {{counter} نقل}}",
  "status.read_more": "بیشتر بخوانید",
  "status.reblog": "تقویت",
  "status.reblog_or_quote": "نقل یا تقویت",
  "status.reblog_private": "هم‌رسانی دوباره با پی‌گیرانتان",
  "status.reblogged_by": "‫{name}‬ تقویت کرد",
  "status.reblogs.empty": "هنوز هیچ کسی این فرسته را تقویت نکرده است. وقتی کسی چنین کاری کند، این‌جا نمایش داده خواهد شد.",
  "status.reblogs_count": "{count, plural, one {{counter} تقویت} other {{counter} تقویت}}",
  "status.redraft": "حذف و بازنویسی",
  "status.remove_bookmark": "برداشتن نشانک",
  "status.remove_favourite": "حذف از موارد دلخواه",
  "status.remove_quote": "برداشتن",
  "status.replied_in_thread": "در رشته پاسخ داده",
  "status.replied_to": "به {name} پاسخ داد",
  "status.reply": "پاسخ",
  "status.replyAll": "پاسخ به رشته",
  "status.report": "گزارش ‎@{name}",
  "status.request_quote": "درخواست نقل",
  "status.revoke_quote": "حذف فرسته‌ام از فرسته @{name}",
  "status.sensitive_warning": "محتوای حساس",
  "status.share": "هم‌رسانی",
  "status.show_less_all": "نمایش کمتر همه",
  "status.show_more_all": "نمایش بیش‌تر همه",
  "status.show_original": "نمایش اصلی",
  "status.title.with_attachments": "{user} {attachmentCount, plural, one {یک پیوست} other {{attachmentCount} پیوست}} فرستاد",
  "status.translate": "ترجمه",
  "status.translated_from_with": "ترجمه از {lang} با {provider}",
  "status.uncached_media_warning": "پیش‌نمایش موجود نیست",
  "status.unmute_conversation": "رفع خموشی گفت‌وگو",
  "status.unpin": "برداشتن سنجاق از نمایه",
  "subscribed_languages.lead": "پس از تغییر، تنها فرسته‌های به زبان‌های گزیده روی خانه و خط‌زمانی‌های سیاهه ظاهر خواهند شد. برای دریافت فرسته‌ها به تمامی زبان‌ها، هیچ‌کدام را برنگزینید.",
  "subscribed_languages.save": "ذخیرهٔ تغییرات",
  "subscribed_languages.target": "تغییر زبان‌های مشترک شده برای {target}",
  "tabs_bar.home": "خانه",
  "tabs_bar.menu": "منو",
  "tabs_bar.notifications": "آگاهی‌ها",
  "tabs_bar.publish": "فرسته جدید",
  "tabs_bar.search": "جستجو",
  "tag.remove": "برداشتن",
  "terms_of_service.effective_as_of": "اعمال شده از {date}",
  "terms_of_service.title": "شرایط خدمات",
  "terms_of_service.upcoming_changes_on": "تغییرات پیش رو در {date}",
  "time_remaining.days": "{number, plural, one {# روز} other {# روز}} باقی مانده",
  "time_remaining.hours": "{number, plural, one {# ساعت} other {# ساعت}} باقی مانده",
  "time_remaining.minutes": "{number, plural, one {# دقیقه} other {# دقیقه}} باقی مانده",
  "time_remaining.moments": "زمان باقی‌مانده",
  "time_remaining.seconds": "{number, plural, one {# ثانیه} other {# ثانیه}} باقی مانده",
  "trends.counter_by_accounts": "‏{count, plural, one {{counter} نفر} other {{counter} نفر}} در {days, plural, one {روز} other {{days} روز}} گذشته",
  "trends.trending_now": "پرطرفدار",
  "ui.beforeunload": "اگر از ماستودون خارج شوید پیش‌نویس شما از دست خواهد رفت.",
  "units.short.billion": "{count}میلیارد",
  "units.short.million": "{count}میلیون",
  "units.short.thousand": "{count}هزار",
  "upload_area.title": "برای بارگذاری به این‌جا بکشید",
  "upload_button.label": "افزودن تصاویر، ویدیو یا یک پروندهٔ صوتی",
  "upload_error.limit": "از حد مجاز بارگذاری پرونده فراتر رفتید.",
  "upload_error.poll": "بارگذاری پرونده در نظرسنجی‌ها مجاز نیست.",
  "upload_error.quote": "بارگذاری پرونده در نقل‌ها محاز نیست.",
  "upload_form.drag_and_drop.instructions": "برای دریافت پیوست رسانه، space را فشار دهید یا وارد کنید. در حین کشیدن، از کلیدهای جهت دار برای حرکت دادن پیوست رسانه در هر جهت معین استفاده کنید. برای رها کردن ضمیمه رسانه در موقعیت جدید خود، مجدداً space یا enter را فشار دهید، یا برای لغو، escape را فشار دهید.",
  "upload_form.drag_and_drop.on_drag_cancel": "کشیدن لغو شد. پیوست رسانه {item} حذف شد.",
  "upload_form.drag_and_drop.on_drag_end": "پیوست رسانه {item} حذف شد.",
  "upload_form.drag_and_drop.on_drag_over": "پیوست رسانه {item} منتقل شد.",
  "upload_form.drag_and_drop.on_drag_start": "پیوست رسانه {item} برداشته شد.",
  "upload_form.edit": "ویرایش",
  "upload_progress.label": "بار گذاشتن...",
  "upload_progress.processing": "پردازش کردن…",
  "username.taken": "این نام کاربری گرفته شده. نام دیگری امتحان کنید",
  "video.close": "بستن ویدیو",
  "video.download": "بارگیری پرونده",
  "video.exit_fullscreen": "خروج از حالت تمام‌صفحه",
  "video.expand": "گسترش ویدیو",
  "video.fullscreen": "تمام‌صفحه",
  "video.hide": "نهفتن ویدیو",
  "video.mute": "خموشی",
  "video.pause": "مکث",
  "video.play": "پخش",
  "video.skip_backward": "پرش به پس",
  "video.skip_forward": "پرش به پیش",
  "video.unmute": "ناخموشی",
  "video.volume_down": "کاهش حجم صدا",
  "video.volume_up": "افزایش حجم صدا",
  "visibility_modal.button_title": "تنظیم نمایانی",
  "visibility_modal.direct_quote_warning.text": "اگر تنظبمات کنونی را ذخیره کنید نقل تعبیه شده تبدیل به پیوند خواهد شد.",
  "visibility_modal.direct_quote_warning.title": "نقل‌ها نمی‌توانند در اشاره‌های خصوصی تعبیه شوند",
  "visibility_modal.header": "نمایانی و برهم‌کنش",
  "visibility_modal.helper.direct_quoting": "اشاره‌های خصوصی روی ماستودون نیم‌توانند به دست دیگران نقل شوند.",
  "visibility_modal.helper.privacy_editing": "پس از انتشار فرسته نمی‌توان نمایانی را تغییر داد.",
  "visibility_modal.helper.privacy_private_self_quote": "خودنقلی فرسته‌های خصوصی نمی‌تواند عمومی شود.",
  "visibility_modal.helper.private_quoting": "فرسته‌ّای فقط پی‌گیران روی ماستودون نمی‌توانند به دست دیگران نقل شوند.",
  "visibility_modal.helper.unlisted_quoting": "هنگامی که افراد نقلتان می‌کنند فرسته‌شان هم از خط‌زمانی‌های داغ پنهان خواهد بود.",
  "visibility_modal.instructions": "واپایش کسانی که می‌توانند با این فرسته تعامل داشته باشند. می‌تواند با رفتن به <link>ترجیحات > پیش‌گزیده‌ها فرستادن</link> تنظیمات را به همهٔ فرسته‌های آینده نیز اعمال کنید.",
  "visibility_modal.privacy_label": "نمایانی",
  "visibility_modal.quote_followers": "فقط پی‌گیرندگان",
  "visibility_modal.quote_label": "چه‌کسی می‌تواند نقل کند",
  "visibility_modal.quote_nobody": "فقط من",
  "visibility_modal.quote_public": "هرکسی",
  "visibility_modal.save": "ذخیره"
}
